Em.I18n.locales ||= {}
module.exports = Em.I18n.locales['en'] =
  bonuses_types:
    referral: "Referral Program"
    rate_order: "Order Rating"
    birthday: "Birthday"
    loyalty_system: "Loyalty System"
    welcome: "Welcome Bonus"
    external: "External Source"
    revoke_added_from_order: "Revoke Added from Order"
    revoke_spent_from_order: "Revoke Spent from Order"
    add_from_order: "Add from Order"
    subtract_from_order: "Subtract from Order"
    loyalty_program_sync: "Sync with External Loyalty Program"
    trigger_mailing: "Trigger Mailing"
    unknown_change_after_sync: "Unrecognized Balance Change After Sync"
    manual: "Manual Balance Change"
    expired: "Expired Bonuses"

  status_mini_popup:
    confirm_sms_hint: 'send SMS notification to the client about order confirmation'
    cancel_sms_hint: 'send SMS notification to the client about order cancellation '

  draft_dish:
    weight_units:
      gram: 'gram'
      kilogram: 'kilogram'
      hundred_gram: '100 grams'
      milliliter: 'mililitre'
      liter: 'litre'
      hundred_milliliter: '100 milliliters'
    weight_units_short:
      gram: 'g'
      hundred_gram: '100 g'
      milliliter: 'ml'
      liter: 'l'
      kilogram: 'kg'
      hundred_milliliter: '100 ml'
    excise_units:
      commodity: 'Commodity'
      excise: 'Excisable Commodity'
      service: 'Service'
      excise_with_label: 'Excisable Commodity without labeling code'
      excise_without_label: 'Excisable Commodity with labeling code'
      commodity_with_label: 'Non-Excisable Commodity with labeling code'
      commodity_without_label: 'Non-Excisable Commodity without labeling code'
      other: 'Other'
  loyalty:
    notifier:
      title: 'Loyalty Program {{text}}'
      status:
        new: 'created'
        old: 'saved'
    confirm:
      delete: 'Delete loyalty program?'
      cancel: 'Cancel changes?'
  client_tag_info:
    notifier:
      title: 'Tag {{text}}'
      status:
        new: 'created'
        old: 'saved'
    confirm:
      delete: 'Delete tag?'
      cancel: 'Cancel changes?'
  bonus_category_info:
    notifier:
      title: 'Category {{text}}'
      status:
        new: 'created'
        old: 'saved'
    confirm:
      delete: 'Remove bonus category?'
      cancel: 'Cancel changes?'
  banner:
    notifier:
      title: 'Banner {{text}}'
      status:
        new: 'created'
        old: 'saved'
    confirm:
      delete: 'Delete banner?'
      cancel: 'Undo changes?'
      save: 'You need to save the banner before uploading the picture. Save?'
  advert:
    notifier:
      title: 'Advert {{text}}'
      status:
        new: 'created'
        old: 'saved'

    filter:
      restaurants:
        zero_data: 'The client must have at least one order from the selected restaurants.'
        content: 'Selected restaurants: {{restaurants}}'

    confirm:
      delete: 'Delete advert?'
      cancel: 'Cancel changes?'
      save: 'You need to save the ad before uploading the photo. Save?'
      execute: 'Confirm the start of the mailing. {{clients}} will be affected'
      cancel: 'Cancel a planned announcement?'

    status:
      draft:'draft'
      scheduled:'started'
      processing:'sending out'
      paused:'the mailing is suspended'
      canceled:'the mailing is canceled'
      complete:'the mailing is completed'

    result:
      error:'Error'
      success: 'Success'

    transport:
      sms:'SMS'
      email:'E-mail'
      client_push_then_sms:'Push, and then SMS'
      client_push:'Push'
      communication_channels: 'Communication сhannels'

  sip:
    status:
      online:'online'
      offline:'offline'
      error:'error'
      connecting:'connection'
      disconnecting:'disconnecting'

    error:
      init_failed:'Invalid SIP account format.'
      connection_failed: 'Failed to connect to SIP proxy server.'
      registration_failed: 'Registration failed. Please check the correctness of the entered data for the connection. '

  c:
    client_tags:
      buttons:
        start_editing: 'edit tags'
        finish_editing: 'finish editing'
        group_editing: 'Group Editing'
        group_add: 'Add Tags to All Clients'
        group_delete: 'Remove Tags from All Clients'
        reset_filters: "Reset Filters"
        confirms:
          accept_reset_filters: 'Filters will be reset to the original state, continue?'
      notification:
        title: 'Completed'
        message: 'Tags for clients updated'
    client_table:
      last_order_date: 'the last order was {{date}}'
      average_check: 'Average check'
    account_photo:
      upload: 'Upload photo'

    add_tag_button:
      add_button: 'Add'
      add_text: 'Add «{{q}}»'
      placeholder:
        search: 'Find a tag'

    banner_photo:
      intro: 'Drag and drop photo or press upload'
      no_photo: 'Photo not uploaded'
      drop_photo: 'Release photo to upload'
      upload: 'Upload'

    advert_photo:
      intro: 'Drag the photo or click upload'
      no_photo: 'No photo uploaded'
      drop_photo: 'Release the photo to upload'
      upload: 'Upload'

    billing_operation_table_row:
      invoice: 'write-off will occur {{date}}'
      invoice_with_act: 'Services rendered {{date}}'
      invoice_date: 'Invoice generated {{date}}'
      download_act: 'Download accounting act'
      download_invoice: 'Download invoice for payment'
      currency: 'rub . '

    carrier_item:
      available_in: 'Available in the cities:'
      rating:
        speed: 'speed'
        price: 'price'
        quality: 'quality'
      connected: 'Connected'
      carrier_sent: 'Application<br>has been sent'
      carrier_sent_hover: 'Send<br>the application again '
      connect:'Connect'

    client_card:
      no_name:'Client with no name'
      address:'Client addresses'
      blacklisted:'Blacklisted client'
      client_comment: 'client comment'
      bonuses:
        none: 'Client has no bonuses'
        one: 'customer {{count}} bonus point on account'
        few: 'Customer {{count}} bonus points on account'
        many: 'Customer {{count}} bonus points on account'
      save: 'Save'
      add_comment: 'add comment to the client'

    client_order_block:
      order_contents: 'Order content'
      item_amount: 'PCS.'
      process: 'Processed'
      unprocess: 'Unprocessed'
      process_error: 'Unable to change the order processing status'

    clients_table_row:
      is_blacklisted: 'Blacklisted client'
      last_order_date: 'the last order was {{date}}'


  error_page:
    header: 'Data loading error'
    comment: 'This usually happens when attempting to open an order or other information where the data is currently unavailable.'
    back_button: 'Return to home'

  themes:
    title: 'Select a theme'
    back_button: 'Back'
    publish_button: 'Publish'
    change_theme: 'Change theme'
    common_settings: 'General settings'
    theme_settings: 'Theme options'
    not_configurable: 'This theme does not have configurable parameters'
    reset_button: 'Reset Settings'

    notifications:
      publish:
        title: 'Published'
        message: '{{theme}} has been published on the restaurant website'
      reset:
        title: 'Success'
        message: '{{theme}} settings reset successfully'

    confirms:
      reset: 'Resetting settings will delete all user preferences. Continue?'



  client_edit:
    header:
      title: 'Customer #'
      first_order: 'First order:'
      order_history: 'Order history'
      activity: 'Customer activity'
      tabs:
        history: 'Order history'
        bonuses: 'Bonuses'
        communications: 'Communications'

    form:
      card_track:
        label: 'Bonus Card'
        placeholder: 'Bonus card number'
      avatar:
        label: 'Photo'
      name:
        label: 'Name'
        placeholder: 'Name'
      phone:
        label: 'Phone'
        placeholder: 'Phone'
        call: 'call'
      email:
        label: 'E-mail'
        placeholder: 'E-mail'
      bonuses:
        label: 'Bonuses'
        placeholder: 'Enter number of bonuses'
        add: 'Add'
        substract: 'Substract'
        confirm_transaction: 'Change the balance?'
        amount:
          none: 'Client has no bonuses'
          one: 'Client {{count}} has bonus points on account'
          few: 'Client has {{count}} bonus points on account'
          many: 'Client has {{count}} bonus points on account'
          other: 'Client has {{count}} bonus points on account'
        count:
          none:   ''
          one:    'bonus'
          few:    'bonuses'
          many:   'bonuses'
          other:  'bonuses'
      issue:
        label: 'Issue code'
      birthday:
        label: 'Birthday'
      tags:
        label: 'Tags'
      recurrence:
        label: 'Returns'
      comment:
        label: 'Comment'
        placeholder: 'Comment'
      black_list:
        label: 'Blacklist'
        control: 'Add to blacklist'
        caption: 'This customer\'s orders will be marked in a special way'
        comment: 'Reason for adding to the blacklist'
        listed_by: 'Who sent to the blacklist and when'
    history:
      header: ' Order history '
      new_order: 'New order'
      change_balance: 'Change balance'
      cancel_balance_change: 'Cancel'
      all: 'All'
      not_processed: 'Unprocessed'
      processed: 'Processed'
      orders_to_show: 'Orders to display'
    buttons:
      save: 'Save'
      delete: 'Delete'
      close: 'Close'

  story_frame_edit:
    header:
      left: 'Frame Images'
      right: 'Frame Parameters'
    button_text: 'Button Text'
    button_url:  'Button URL'
    photo_help: 'Drag an image or click to upload'
    no_photo: 'No frame image uploaded'
    drop_photo: 'Drop the image to upload'
    save_banner_for_edit: 'You need to save the banner before making changes. Save?'

  dish_edit:
    photo:
      tabs:
        main: 'Main Photo'
        additional: 'Additional Photos'
    photo_help: 'Drag photo or press upload'
    no_photo: 'Dish photo is not uploaded <br>
              upload a photo, so that it will be displayed on the website'
    buttons:
      upload: 'Upload'
    availability:
      title: 'Availability of dishes in a restaurant'
      about_availability: 'Here you can hide a dish in the restaurant menu, or mark availability of a dish to be by calling confirmed'
      enabled_timetable: 'An availability timetable has been defined for the dish.'
      about_timetable: 'The availability timetable allows you to automate the set and unset of a dish from the stop-list.'
      edit_timetable: 'Edit timetable'
      no_available: 'Temporarily not available'
      need_call: 'Specify by phone'
      loading: 'Loading'
    configurator:
      new_configurator_title: 'New configurator #{{ordinal}}'
      confirm:
        remove_modifier_scheme: 'Remove dish configurator?'
        remove_group_binding: 'Remove a bound group?'
      placeholders:
        item_name: 'name'
        item_price: 'price'
      buttons:
        add_new_group:
          dish_group: 'Add Combo'
          modifier_group: 'Add Modifier Group'
        delete_configuration: 'Delete configuration'
        configuration_settings: 'Configure settings'
        add_new_configuration: 'Add new configuration'
        remove_group: 'Remove group'
        remove_group_parent: 'By default'
      config_types:
        label: 'Configuration Type'
        modifier_group: 'Modifier Group'
        dish_group: 'Combo'
      type:
        modifier_group: 'Modifier Group Setup'
        dish_group: 'Combo Setup'
      parent: 'Depends on modifier'
      labels:
        base_price: 'Base price'
        allow_additional_comment: 'Allow comments'
      configuration_settings: 'Configure configuration'
      add_new: 'Add position'
      base_price_caption: 'Used to start calculating the total price of a configured dish'
      groups_zero_data: 'No group has been added yet'
      multiple_select:
        title: 'Multiple options can be selected'
        min: 'Not less than'
        max: 'and no more than'
        about: 'options'
      zero_data:
        title: 'No configurations yet'
        caption: 'Configuration will allow customer to choose dish options. For example, a choice of sauce, additive, or serving size'
      allow_additional_comment_caption: 'Allows guests to add comments to the dish when ordering'

    header:
      edit: 'Editing dish'
      readonly: 'Dish parameters'
      tabs:
        configurator: 'Configurator'
        prices: 'Restaurant prices'
      configurator:
        edit: 'Configurator'
        readonly: 'Configurator (view only)'
    form:
      slug:
        label: 'Slug'
        placeholder: 'Slug'
      ingridients: 'Ingredients'
      calories: 'Calories'
      proteins: 'Proteins'
      fats: 'Fats'
      carbs: 'Carbohydrates'
      title:
        app: 'Website and App'
        description: 'Description'
        integrations: 'Integrations'
        promos: 'Promotions and Bonuses'
        additional: 'Additional'
      name:
        label: 'Name of dish'
        placeholder: 'Name of dish'
      price:
        label: 'Price'
        placeholder: 'Price'
      weight_price:
        label: 'Price per {{unit}}'
        placeholder: 'Price per {{unit}}'
      price_weight_unit:
        label: 'Units of measure to calculate the price'
        placeholder: ''
      weight:
        label: 'Weight'
        placeholder: 'Weight'
      weight_unit:
        label: 'Units of measure'
        placeholder: ''
      excise_unit:
        label: 'Units of excise'
        placeholder: ''
      external_id:
        label: 'External code (id)'
        placeholder: 'id'
        caption: 'used when integrating Smartomato widget'
      description:
        label: 'Description'
        placeholder: 'Description'
      category:
        label: 'Category'
      suggesting:
        label:
          on: 'Priority for recommendation'
          off: 'Recommend this dish?'
        priority: 'Priority'
        disable: 'disable'
        caption: 'You can set a large number of dishes for additional sales, then the priorities will allow Smartomato to choose the most suitable for the recommendation.'
        enable: 'Enable the dish in the add. sales'
      disabled_sources:
        label: 'Aggregator export restriction'
        caption: 'You can restrict dished for export to certain aggregators'
      extras:
        label: 'Extras'
        is_list: 'Show in text form'
        can_zoom: 'You can enlarge the picture'
        is_hidden: 'Hide in the menu'
        is_stealthy: 'Hide from menu'
        is_bonus_only: 'Dish only for bonuses'
        no_bonus_accrue: 'Do not add bonuses for this dish'
        dont_discount: 'Do not give any discount for this dish'
        unaccounted_for_promo: 'Do not account for when calculating order total for promotions'

        prohibit_takeaway: 'Prohibit dish for takeaway orders'
        prohibit_delivery: 'Prohibit dish for delivery orders'
        prohibit_dine_in: 'Prohibit dish in order to the table'
        is_popular: 'Display in a block of popular dishes'
        restrict_bonus_withdrawal: 'Prohibit bonuses from being deducted for this dish'
        is_required: 'Required dish'
      is_next_day:
        label: 'Next day delivery'
        toggle: 'Dish with next day delivery'
        hour_count: 'Hours quantity from the beginning of next day'
        caption: 'By default, orders with such a dish will be postponed to the beginning of the next day and then take time from delivery zones. <br> <br> \
              But if the delivery works after midnight, such dishes will be postponed to 00:01. <br> <br> \
              The number of hours will move the time forward by the specified number of hours. <br> <br> \
              You can set the time globally for the entire organization (write us in the chat) or individually for each dish.'
      is_metric:
        label: 'Weight dish'
        toggle: 'Weight dish'
      min_qty:
        weight: 'Minimum weight ({{unit}})'
        volume: 'Minimum volume ({{unit}})'
      delta_qty:
        weight: 'Weight increment ({{unit}})'
        volume: 'Volume increment ({{unit}})'
      cooking:
        time:
          label: 'Cooking time'
          placeholder: 'Time'
          caption: 'Cooking time in minutes for calculating the cooking schedule. <br> Leave blank if you want to use the cooking time from the delivery area'
          unit: 'min'
        line:
          label: 'Restaurant workshop'
          caption: 'Cooking line within which the dish will be prepared'
      old_price:
        label: 'Old price'
        placeholder: 'Old price'
        caption: 'It will be displayed striked through'
      tags:
        label: 'Badges'
        placeholder : 'Vegetarian, Low-calorie, Spicy'
        caption: 'You can specify words separated by commas, each such word will become a badge on the website'
      meta_title:
        label: 'Meta title'
        placeholder: 'meta title'
      meta_description:
        label: 'Meta description'
        placeholder: 'meta description'
    prices:
      price:
        label: 'Price'
        is_hidden: 'not in the menu'
        is_default: 'now prices and availability default '
        override:' override '
      base_price:
        label:' Base configurator price '
      disable:' disable different prices'
      zero_data:
        header: 'Prices and availability in different restaurants'
        caption:' Now the dish is included in the menu of all restaurants at the same price '
        enable : 'Set different prices or availability'

    buttons:
      save: 'Save'
      delete: 'Delete'
      cancel: 'Cancel'

  category_edit:
    new: 'New category'
    header:
      edit: 'Editing a category'
      readonly: 'Category parameters'
    form:
      disclaimer:' ＊ Supported only in the themes'
      name:
        label: 'Title categories'
        placeholder: 'Category name'
      external_id:
        label: 'External code (id)'
        placeholder: 'id'
        caption: 'is used when integrating with restaurant accounting systems'
      description:
        label: 'Description'
        placeholder: 'Description'
      parent:
        label : 'Parent category'
      export_hidden:
        label : 'Export hidden to aggregators'
      disabled_sources:
        label: 'Disallow Export to Aggregators'
        caption: 'You can prohibit the export of a category to a specific aggregator or multiple aggregators'
      extras:
        label: 'Optional'
        is_list: 'Display content as text (only in the themes part)'
        is_hidden: 'Hide in the menu'
        age_restriction: 'Age restriction'
        toggle_hidden_recursively: 'Hide/Show all dishes in restaurants'
        toggle_hidden_restaurant_id: 'Select a restaurant'
        toggle_hidden:
          true: 'Hide'
          false: 'Show'
      meta_title:
        label: 'Meta title'
        placeholder: 'meta title'
      meta_description:
        label: 'Meta description'
        placeholder: 'meta description'


    buttons:
      save: 'Save'
      delete: 'Delete'
      cancel: 'Cancel'

  reports:
    sidebar:
      report_type: 'Report type'
      add_filter: 'Add filter'
      condition_and: 'condition or'
      condition_or: 'condition and'
      remove_filter: 'Remove filter'
      choose: 'select'
      group_by: 'Group by'
      execute_button:'Execute'
    content:
      loading: 'Generating report ...'
      zero_data:
        header: 'Report Designer'
        caption: 'Select the required report type, set conditions using filters and click "Execute"'

  orders:
    sidebar:
      filters:
        reset: 'Reset'
        apply: 'Apply'
        status: 'Status: '
        restaurant: 'Restaurant: '
        zone: 'Zone: '
        courier: 'Courier: '
        date: 'Delivery Date: '
        zeroData: 'No filters selected'
        elepsis: 'and other filters'
      now: 'Now'
      later: 'Later'
      all: 'All'
      placeholders:
        search: 'Smart search'
      sections:
        organization: 'Organization'
        is_bk: 'Exclude food for couriers'
        status: 'Order status'
        date_range: 'Delivery period'
        separator: 'to'
        client_rate: 'Customer rating'
        restaurants: 'Restaurants'
        deliveryZones: 'Delivery zones'
        assigned_couriers: 'Assigned couriers'
        order_sources : 'Order source'
        payment_sources: 'Payment source'
        payment_status: 'Online payment status'
        archive_orders: 'Show orders older than two weeks'
        orders_count: 'Orders shown {{ordersLength}} / {{ordersCount}}'
        delivery_types: 'Delivery type'
      buttons:
        show_limit_orders: 'Show all orders'
        search_query: 'Waiting for the end of typing..'
    table:
      no_number: 'no number'
      no_text: 'not specified'
      assign_courier: 'assign'
      order_change: 'change for'
      content:
        number: "#"
        status: 'Status'
        published_at: 'Received'
        restaraunt: 'Restaurant'
        client: 'Client'
        address: 'Address'
        client_rate: 'Rating'
        tag: 'Category'
        pos_status: 'POS status'
        delivery_at: 'Deliver'
        delivery_at_range: '{{day}} from {{from}} to {{to}}'
        courier: 'Courier'
        confirmed_by: 'Operator'
        payment_source: 'Payment'
        final_sum: 'Order amount'
        delivery_price: 'Delivery cost'
        source: 'Source'
        delivery_zone: 'Zone'
        loading: 'Loading orders'
        zero_data:
          archive_not_found: 'No orders found'
          archive_limited: 'The selection is limited to the last two weeks'
          archive_limited_caption: 'To access archived orders, turn on the "Display orders older than two weeks" in the filter panel checkbox'
  courier_apps:
    header: 'It\'s time to install the courier app!'
    comment_start: 'It looks like you are logged in as Smartomato courier. You will see the orders assigned to you in the section '
    orders_button: 'Orders'
    comment_end: ', but you will not be able to confirm them or manage delivery.'
    setup_application: 'To manage your orders, please install the courier app for Android or go to the online order management interface adapted for tablets.'
    button_ios_app: 'App for iOS'
    button_android_app: 'App for Android'
    button_mobile_app: 'Web interface for tablets'
    goto_orders: 'Go to the Orders section'

  clients:
    client_card:
      registered: 'Registered {{when}}'
      lastorder: 'Last order {{when}}'
      birthdate: 'Birthday {{when}}'
      card: 'Loyalty card: №{{number}}'

    clients_count:
      one: 'client'
      few: 'clients'
      many: 'clients'
      other: 'clients'

    bonuses_count:
      one: 'bonus'
      few: 'bonuses'
      many: 'bonuses'
      other: 'bonuses'

    filter:
      smart_search: 'Smart search'
      tags: 'Tags'
      no_tags_message: 'You don\'t have tags yet, add them on the customer card and define its category.'
      dishes: 'Ordered dishes'
      recurrence: 'Recurrence returnable'
      order_status: 'Order status'
      delivery_type: 'Delivery type'
      sources: 'Sources'
      organizations: 'Organizations'
      cities_restaurants: 'Cities (by restaurants)'
      unrestricted: 'Unlimited'
      restaurants: 'Restaurants'
      order_period: 'Order period'
      average_check: 'Average bill'
      orders_count: 'Number of orders'
      black_list: 'Blacklist'
      from: 'from'
      to: 'to'

    index:
      sort_by: 'Sort:'
      found: 'Found'
      recurrence_change_dynamics: 'dynamics of change in return rate'
      percent: 'in percent'
      absolute: 'absolutely'
      loading: 'Loading clients'
      nothing_found: 'No clients found'
      nothing_found_comment: 'Try changing the filtering parameters'

    client_type:
      'new':
        one: 'new'
        few: 'new'
        many: 'new'
        other: 'new'
      active:
        one: 'active'
        few: 'active'
        many: 'active'
        other: 'active'
      returned:
        one: 'returned'
        few: 'returned'
        many: 'returned'
        other: 'returned'
      cold:
        one: 'cooled down'
        few: 'cooled down'
        many: 'cooled down'
        other: 'cooled down '
      dead:
        one: 'lost'
        few: 'lost'
        many: 'lost'
        other: 'lost'

    recurrence_filter:
      'new': 'New'
      active: 'Active'
      returned: 'Returned'
      cold: 'Cold'
      dead: 'Lost'

    recurrence_label:
      'new': 'New'
      active: 'Active'
      returned: 'Returning'
      cold: 'Cold'
      dead: 'Lost'

    recurrence_label_long:
      'new': 'New client'
      active: 'Active client'
      returned: 'Returning client'
      cold: 'Cold client'
      dead: 'Lost client'

    recurrence_comment:
      'new': 'Client made the first order'
      active: 'The client has been ordering regularly for more than 2 weeks'
      returned: 'The client has started ordering again'
      cold: 'The client has not ordered for more than 2 weeks'
      dead: 'The client has not ordered for more than 1 month'

    order_source:
      delivery_club: 'Delivery Club'
      foodfox: 'Yandex.Eda'
      obed_ru: 'Obed.ru'
      broniboy:     'Broniboy'
      chibbis: 'Chibbis'
      glovo: 'Glovo'
      vk: 'Vk'
      sbermarket: 'Sbermarket'
      external_aggregator: 'External aggregator'
      wolt: 'Wolt'
      yandex_lavka: 'Yandex.Lavka'

      external_site: 'External website'
      external_site_mobile: 'External website (mobile version)'
      marketplace: 'Marketplace'
      marketplace_mobile: 'Marketplace (mobile version)'
      board: 'Board'

      mobile_application_ios: 'iOS Application'
      mobile_application_android: 'Android Application'
      iiko: 'iiko'

    orders:
      one: 'order'
      few: 'orders'
      many: 'orders'
      other: 'orders'

    # sort:
    #    orders_count_asc: 'increase the number of orders'
    #    orders_count_desc: 'decrease the number orders'
    #    average_check_asc: 'increasing the average check'
    #    average_check_desc: 'decreasing the average check'
    #    created_at_asc: 'increasing the registration date'
    #    created_at_desc: 'decreasing the registration date'

    sort:
      orders_count: 'by the number of orders'
      average_check: 'by the average check'
      created_at: 'by registration'
      bonus_count: 'by bonus balance'

  date:
    today: 'today'
    tomorrow: 'tomorrow'
    yesterday: 'yesterday'
    by: 'to'
    at: 'in'
    during: 'during'
    during_days:
      one: '{{count}} day '
      few:' {{count}} days '
      many:' {{count}} days '
      other:' {{count}} days '

    during_hours:
      one: '{{count}} hours'
      few: '{{count }} hours'
      many:' {{count}} hours'
      other:' {{count}} hours'

    during_minutes:
      one: '{{count}} minutes '
      few: '{{count}} minutes '
      many: '{ {count}} minutes'
      other: '{{count}} minutes'

    during_seconds:
      one: '{{count}} seconds'
      few: '{{count}} seconds'
      many: '{{count}} seconds'
      other: '{{count}} seconds'
    week_days: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],

  billing:
    form:
      settings:
        title: 'Account replenishment',
        caption: 'After confirmation you will be redirected to the payment window'
        labels:
          sum: 'Sum'
        buttons:
          pay: 'Pay'
          cancel: 'Cancel'
      header: 'Tariff plan settings'
      set_payment_method: 'Select a payment method'
      update_requisites: 'Update requisites'
      enable_pay_by_card: 'Enable card payment'
      enable_pay_by_bank: 'Enable payment by bank transfer'
      empty_subheader: 'Tariff the plan affects the restrictions associated with the use of the service '
      current_tariff: 'Your current tariff is "{{tariff}}"'
      unit: 'RUB / month'
      change_tariff: 'Change tariff'
      payment_method: 'Payment method'
      change_payment_method: 'Change payment method'
      state:
        normal:
          header: 'Everything has been paid'
          comment: 'Next write-off {{date}}'

        free:
          header: 'Free tariff'

        invoices:
          header: 'To pay {{sum}} rub.'
          comment: 'Pay by {{date}}'

        dept:
          header: 'Payable {{sum}} rub.'
          comment: 'The service will be available until {{date}}'

        blocked:
          header: 'The organization is blocked'
          comment: 'The block was made {{date}}'

        paywall:
          header: 'Test period'
          comment: 'Before {{date}} the trial period is valid. Please select a plan before it expires. '

        paywall_deadline:
          header: 'The trial period has expired'
          comment: 'The trial period has ended. Please select a tariff plan to continue working. '
      choose_tariff: 'Select a tariff plan'
      choose_tariff_and_setup_payment: 'Select a tariff plan and set up a payment method'
      pay_button_dept: 'Deposit account'
      pay_button: 'Pay'
      operations:
        header: 'Account transactions history'
        table:
          date: 'Date'
          operation: 'Operation '
          sum: 'Amount'
      balance:
        label: 'On your account'
        currency: 'rub.'

    payment_method:
      tab_card:
        header: 'No special settings are required to pay by card'
        content: 'Once a month, you will need to click on the payment link that we will send and pay the next sum.'
      header: 'Setting the payment method Smartomato'
      comment: 'You can pay for the subscription through a current account or by bank card'
      tabs:
        card: 'Bank card'
        bank_account: 'Current account'
      bank_details:
        header: 'Organization details:'

        payer_name:
          label : 'Name of the legal entity'
          placeholder: 'Los Pollos Hermanos LLC'
        inn:
          label: 'INN'
          placeholder: ''
        kpp:
          label: 'KPP'
          placeholder: ''
        address:
          label: 'Legal address'
          placeholder: 'Required for billing'
        settlement_account:
          label: 'Settlement account'
          placeholder:''
        corresponding_account:
          label: 'Corresponding account'
          placeholder: ''
        bik:
          label: 'BIC'
          placeholder: ''
        bank_name:
          label: 'Bank name'
          placeholder: ''
        signer:
          label: 'Signatory, full name'
          placeholder: 'Ivanov I.I.'
        role:
          label: 'Subscriber, position'
          placeholder: 'General Director'

        act_subheader: 'Data for forming the act of rendered services'




    tariffs:
      header: 'Choose the tariff plan that suits you best'
      subheader: 'You can change the tariff plan at any time'

      change_tariff :
        plain: 'Switch to the tariff "{{tariff_name}}" '
        paywall: 'Start using the tariff plan'
        paywall_before_deadline: 'Start using the service on the tariff plan'

    warnings:
      trial_period: 'The trial period is currently valid. Please select a plan before {{deadline}}. '
      paywall_warning: '{{deadline}} evaluation period ends. Please select a tariff plan to avoid blocking. '
      paywall_expired: 'The trial period has ended. Please select a tariff plan to continue working. '

      free_tariff: 'You are on a free tariff, orders on the website are not working'
      blocked: 'The organization is blocked due to non-payment, orders on the website are not working'
      rush_mode_restaurants: '🔥 High demand mode is enabled in some restaurants: {{disabled}} from {{total}} '
      blocked_restaurants: '🔒 Some restaurants are blocked for taking orders: {{disabled}} from {{total}}'
      dept_detected: 'You have a debt, pay {{sum}} before {{deadline}} to avoid blocking'
      pending_invoices: 'Before {{deadline}}, you must pay {{sum}} for using the Smartomato service'
    notifications:
      change_tariff_error: 'Error'


  order:
    contact_call_allowed: "Call required 📞"
    contact_call_not_allowed: "Do not call ⚠️"
    organization_select_text: 'Select an organization'
    status_mini_popup:
      client_notification_type_call: 'Need to call client'
      annotation: 'Manage the current progress of the order'
      cancel_reason: 'Specify the reason for cancellation'
      placeholders:
        cancel_reason_comment: 'Specify the reason for cancellation'
      buttons:
        change_status: 'Change status'
        open_history: 'View change history'
    map_popup:
      warning:
        order_unpaid: '⚠️ ORDER NOT PAYED YET'
        order_expired: '⚠️ ORDER IS LATE'
      order_name: 'Order # {{order}}'
      takeaway: 'takeaway'
      delivery_price: 'delivery {{currency}}'
      delivery_free: 'free shipping'
      payment_source: '{{paymentSource}}'
      choose_self_courier: 'Select courier'
      time:
        cooking_start: 'Start cook'
        cooking_start: 'Start cooking'
        pick_up_at: 'Pick up order'
        delivery_at: 'deliver order'
        shelf_time: 'The suitability of the order to'
      outsource:
        outsource_courier: 'Assigned courier'
        no_delivery_request: 'The application for the delivery has not yet been posted'
        outsource_courier_pickup_time: 'Courier will be:'
        outsource_delivery_price: 'Price outsource delivery:'
        outsource_messages: 'Messages'
      buttons:
        confirm: 'Confirm order'
        dispose: 'Write off order'
      client_notification_type_call: 'Need to call client'
    courier_mini_popup:
      external_delivery: 'The order is outsourced at {{externalDelivery}}'
      selected_courier:
        courier_free: 'The courier is free'
        distance: 'Distance to restaurant'
        order_number: 'Order #{{order}}'
        no_address: 'no address'
        picked_up_at: 'Picked up at'
        pick_up_at: 'Pick up at (plan)'
        delivery_at: 'Delivery at'
      annotation:
        choose_self : 'Select the courier who will deliver the order'
        non_created_outsource: 'The request for outsourcing delivery in {{externalDelivery}} has not been created'
        confirm_create_outsource: 'Confirm our sourcing to {{externalDelivery}}'
        cancel_courier_assign: 'Click the courier one more time to remove its assignment '
        external_courier: 'Proceeding will cancel the claim in {{externalDelivery}}'
        self_courier: 'You will be able to assign order to your own courier'
        cancel_self_before_place: 'Unassign your own courier to outsource the order to {{externalDelivery}}'
        error: 'Error'
      buttons:
        back: 'back'
        cancel_outsource_delivery: 'Confirm cancelling outsource'
        cancel: 'Cancel'
        place_outsource: 'Place outsource'

    time_mini_popup:
      annotation: 'Specify time intervals for order processing'
      section:
        cooking_start_at: 'Start cooking'
        pick_up_at: 'Pick up order'
        delivery_at: 'Deliver order'
      buttons:
        save: 'Save'
      takeaway: 'Pickup'
      order_name: 'Order # { {order}}'
      payment_source: '{{paymentSource}}'
      time:
        cooking_start: 'Start cooking'
        delivery_at: 'Deliver order'
      buttons:
        confirm: 'Confirm order'
    feasibility_warnings:

      transportation_time: 'The order may not be in time to DELIVER. It took {{transportation_time}} minutes, but you get {{trans_time}} minutes.'
      cooking_time: 'The order may not have time to PREPARE. It took {{cooking_time}} minutes, but you get {{cook_time}} minutes. '

    problems:
      is_past_delivery_end_deadline:       'The order was not delivered on time'
      is_past_delivery_start_deadline:     'The order was not delivered to the courier on time'
      is_past_cooking_end_deadline:        'The order was not cooked on time'
      is_past_cooking_start_deadline:      'Cooking did not start on time'
      is_past_confirm_deadline:            'Order was not confirmed in time'
      is_past_payment_deadline:            'Order has not been paid yet'
      is_past_courier_deadline:            'Courier not assigned in time'
      is_past_restaurant_confirm_deadline: 'Restaurant has not confirmed order'


    payment_method:
      cash: 'in cash'
      card: 'by card online'
      courier_card: 'by card to the courier'
      delivery_card_card_online: 'on Delivery Club website'
      external_service_card_online: 'online on an external service'
      extra_bonuses: '+ bonuses'
    pos_status:
      pending: 'Waiting for export'
      error: 'Export error'
      success: 'Export success'

    delivery_type:
      takeaway: 'takeaway'
      delivery: 'delivery by courier'
      dine_in: 'dine-in'

    asap_type:
      specified_time: 'by a certain time'
      asap: 'as soon as possible'

    status:
      draft: 'Draft'
      pending: 'New'
      confirm: 'Confirmed'
      preparing: 'Preparing'
      prepared: 'Prepared'
      delivery: 'At the courier'
      complete: 'Delivered'
      undo: 'Canceled'

    scheduled: 'Assigned to {{when}}'
    takeaway: 'Pickup'
    dine_in: 'Dine-in'

    bonus_card:
      title: 'Bonuses and discounts'
      discount: 'Discount on order'
      bonus_dish: 'Select dish:'

    content:
      edit:
        item_free: 'free'

    summary:
      items_sum: 'order'
      delivery_price: 'delivery'
      used_bonuses: 'bonus points'
      discount_sum: 'discount'
      commission_sum: 'commission'
      service_charge_amount: 'service charge'
    edit:
      do_time_update: 'Make adjustments to the remaining time points?'
      configurator:
        comment: 'Comment'
        labels:
          total_price: 'Total'
        placeholders:
          comment: 'Additional wishes'
      order_now_viewing: 'The order is currently being viewed:'
      draft_status_notice: 'You cannot control the status of a draft order. Use the "place" button to transfer the order to the "new" status'
      normal_header: 'Order # {{number}} '
      draft_header: 'Draft order'
      order_content_header: 'Order content'
      published_at: 'posted {{when}} '
      reset_change: 'change is not needed?'
      address_warning: 'House number was not found'
      pos_error:
        label: '⚠️ Error sending to POS'
        retry_export_disabled: '⛔ Resend order limit reached'


      client_search: 'Searching for a client ...'
      new_client: 'This client is not yet in your database'

      edit_order: 'edit'
      finish_editing: 'finish'
      delete_confirm: 'Are you sure you want to delete the order?'

      payment:
        warning: '⚠️ The order has not been paid yet.'
        success: '✅ Order paid for'

      sync:
        synced: 'Order saved in {{when}}'
        syncing: 'Saving ...'
        error: 'Saving error!'

      history:
        empty_history: 'no change history'
        loading_text: 'Loading history ...'

      delivery_zone:
        minimal_order_price: 'Minimum order:'
        delivery_time: 'Delivery time:'
        free_delivery_price: 'Free from:'
        time_unit: 'min.'
        delivery_price: 'Delivery price:'
      labels:
        status: 'Status'
        restaurant: 'Restaurant'
        comment: 'Comment'
        change: 'Need change with'
        use_bonuses: 'Pay with bonuses'
        payment: 'Payment'
        qr_payment_status: 'Payment status via QR'
        takeaway: 'Pickup point'
        when_delivery: 'Delivery'
        when_pickup: 'Pick up'
        client_delivery_at: 'When to send to the client'
        cooking_start_at: 'When to start cooking'
        table: 'Table'
        delivery_at: 'When to deliver'
        pick_up_at: 'When to pick up from the restaurant'
        client:
          phone: 'Phone'
          name: 'Name'
          rate: 'Customer rating'
        delivery_type: 'Delivery type'
        city: 'City'
        delivery_address: 'Delivery address'
        delivery_zone: 'Delivery area'
        delivery_price: 'Delivery price'
        use_promo_code: 'Specify promo code'
        used_promo_code: 'Used promo code'
        courier: 'Courier'
        use_delivery: 'Deliver'
        tag: 'Category'
        pos_status: 'POS status'
        staff_comment: 'Staff comment'
        cutlery: 'Cutlery amount'
      buttons:
        add_dish: 'Add dish'
        close: 'Close'
        place: 'Place'
        more_details: 'show more details'
        only_statuses: 'show only statuses'
      placeholders:
        address: 'Address'
        apartment: 'apartment'
        floor: 'floor'
        staircase: 'entrance'
        address_comment: 'comment to address'
        buddy_name: 'Specify name'
      hints:
        geocode_order: 'Define delivery zone'
      dish_selection:
        title: 'Select dish'
        nothing_found: 'Nothing found'
        is_hidden: 'Hidden in menu'
        buttons:
          back: 'Back'
        placeholders:
          search:' Searching for a dish '
      bonus_amount:
        none: ''
        one: 'Available for use: {{count}} bonus points'
        few: 'Available for use: {{count}} bonus points'
        many: 'Available for use: {{count}} bonus points'


  monitor:
    notifications:
      common_title: 'Order # {{number}} - {{name}} '
      new_order_title: 'New order # {{number}} '
      paid: 'Order # { {number}} paid for '
      confirm_deadline: 'The order arrived {{when}} but still not confirmed '
      cooking_start_deadline: 'The order should have started preparing {{when}}, but is still in "{{status}}"'
      cooking_end_deadline: 'The order should have been prepared {{when}}, but still in "{{status}}"'
      delivery_start_deadline: 'The order should have been with the courier {{when}}, but still in the status "{{status}}"'
      delivery_end_deadline: 'The order should have been delivered {{when}}, but still in the status "{{status}}"'
      payment_deadline: 'The order has not yet been paid'
      courier_deadline:' The order has been picked up from the restaurant {{when}}, and the courier has not yet been assigned '
      status_changed: 'The order has moved to status "{{status}}"'
      courier_confirmed: 'Courier {{courier_name}} confirmed order '
      restaurant_confirmed: 'Order confirmation received by restaurant {{restaurant_name}} '
      just_created: 'Confirm order {{when}} '
      restaurant_confirm_deadline: 'Order has not yet been confirmed by restaurant '
      cooking_start: 'Start cooking. Fetching an order from the restaurant {{when}} '

      active_order: 'The deferred order returned to work, delivery {{when}} '
      delayed_order: 'The order has moved to the category "deferred" '

  # ---
  # Configurator
  # ---
  configurator:
    validations :
      single_select: '{{groupName}}: you must select exactly one option'
      multiple_select: '{{groupName}}: you must select from {{min}} to {{max}} options'

  currency: '{{price}} rub . '
  dashboard:
    sidebar:
      done_title: 'Prepare the restaurant site for launch'
      done_caption: 'Great! Your site is ready to go. We\'ll tell you soon how to boost sales and improve efficiency. '
      header: 'Prepare the restaurant site for launch'
      progress: 'Completed {{done}} / {{total}}'
    main:
      restaurant_multiselect: 'Display data for all available restaurants'
      zero:
        title: 'Restaurant statistics'
        text: 'We do not yet have enough information to display the actual sales dynamics, peak loads and frequency map of orders'
        disclaimer: 'Sample data'
      range:
        week: 'Week'
        month: 'Month'
        year: 'Year'
    dynamics:
      orders_summary:
        one: 'order'
        few: 'orders'
        many:' orders'
        other : 'orders'
      revenue: 'total revenue'
      average_check: 'average check'
      header: 'Dynamics of orders'
      pie_chart_caption: 'Client revenue structure'
      bar_chart:
        header: 'Peak loads during the day'
        work_days: 'Weekdays'
        weekends: 'Weekends'
        whole_week: 'All week'
      baskets:
        map_header: 'Map of orders'
        dishes_header: 'Popular dishes'
        loading: 'Loading data ...'
        dish_unit: 'pcs.'




  sm_select:
    placeholder:
      zero: 'None selected'
      one: 'Selected {{count}} element'
      few: 'Selected {{count}} element'
      many: 'Selected {{count}} elements'
      other:' Selected {{ count}} elements'

  staff:
    roles:
      admin: 'Administrator'
      regional_admin: 'Regional administrator (franchisee)'
      manager: 'Manager'
      manager_logist: 'Logistic manager'
      logist: 'Logistician'
    notifications:
      order_created: 'New order'
      order_restaurant_confirmed: 'Acceptance of an order by a restaurant'
      order_courier_confirmed: 'Confirmation of an order by a courier'
      order_cooking_start: 'Arrival of an order to the kitchen'
      billing_event: 'Payment for Smartomato services'
      negative_rate_received: 'Receive a negative evaluation for an order '
      restaurant_running_changed: 'Switching the restaurant on or off'
      pos_order_export_error: 'Receive errors when submitting an order to the cashier'
      client_message_created: 'Incoming message from client'
      communication_channel_updated: 'Channel status update'


  staff_table:
    is_me: 'This is you'
    in_restaurant: 'in restaurant'

  checklist:
    theme_selected: 'Select a website design '
    several_menu_filled: 'Add dishes '
    has_delivery_zones: 'Set the zone and delivery terms '
    has_couriers: 'Connect couriers '
    has_address_phone: 'Enter the phone number and address of the restaurant '
    has_domain: 'Select the domain '
    is_published: 'Publish the site '



  menu:
    channels: 'Channels'
    static_pages: 'Pages'
    sandbox: 'UI'
    organizations: 'Organization '
    analytics: 'Web analytics and SEO '
    restaurants: 'Restaurants '
    couriers: 'Couriers '
    delivery: 'Delivery '
    dishes: 'Menu '
    themes: 'Website '
    mobile_app: 'Mobile app'
    orders: 'Orders '
    billing: 'Tariff plan '
    profile: 'Profile settings '
    staff: 'Employees '
    business_role: 'Business roles'
    sip: 'Telephony '
    support: 'Help '
    clients: 'Clients '
    promos: 'Promotions '
    map: 'Map '
    organization_settings: 'Organization settings '
    organization_settings_header: 'Settings '
    payment_methods: 'Order payment methods '
    integrations: 'Integrations'
    integrations_settings:   'Integrations settings'
    logout: 'Logout'
    utilities: 'Advanced'
    interface: 'Interface settings'
    reports: 'Reports'
    promo_constructor: 'Promotions'
    loyalty_programs: 'Loyalty programs'
    bonus_categories: 'Bonus categories'
    ads_and_push: 'Ads and mailings'
    banners: 'Banners'
    client_tags: 'Tags'
  login:
    please_authorize: 'Please log in'
    login_placeholder: 'Login'
    password_placeholder: 'Password'
    sign_in: 'Login'
    cant_login: 'Failed to login!'
    label_restore_password: 'Enter the email address to which we will send an email with instructions to reset the password'
    mail: 'Mail'
    send_password: 'Send password'
    cancel: 'Cancel'
    login: 'Login'
    password: 'Password'
    password_restore_was_send: 'Email from password reset instruction has been sent to your email '
    captcha_error: 'Error! Confirm that you are not a robot.'
    sign_up_link: 'Sign up,'
    sign_up_link_comment: 'if you don\'t have an account'
    restore_button: 'Forgot your password?'

  notifications:
    organization_saved:
      title: 'Saved'
      message: 'The organization was successfully saved.'

    restaurant_saved:
      title: 'Saved'
      message: 'The restaurant has been successfully saved.'

    restaurant_error:
      title: 'Error'
      message_fallback: 'An error occurred while saving the restaurant'

    restaurant_destroy_error:
      title: 'Unable to delete'
      message_fallback: 'Check that this restaurant does not contain delivery and order zones'

  categories:
    published_at: 'Last published on {{date}} at {{time}} '
    not_published: 'Menu has not been published yet '
    publish: 'Publish menu '
    add_category: 'Add category '
    edit_placeholder: 'Enter name '
    upload_photo: 'Upload photo '
    delete_category: 'Delete category '
    add_dish: 'Add dish '
    zero_data:
      header: 'No category selected '
      caption: 'Select a category to view details or start editing. '
    editConfigurator: 'Configurator settings'
    search: 'Search'

    confirm:
      save_before_photo: 'You need to save the category before uploading the photo. Save?'
      delete: 'Delete category? All dishes from the category will be deleted.'

    new_configurator:
      categories: 'Categories'
      modifiers: 'Modifiers'
      help: 'Modifiers are characteristics of dishes that add a certain property or cooking feature to them (for example, "no salt", "with lemon", etc.). ).
            <br>
            <br>
            modifiers are convenient to use as a constructor for a business lunch, burger or noodles in a box '

  dish_groups:
    title: 'Combo Setup'
    new_group: 'New Combo'
    dish_group:
      header: 'Dish List'
      comment: 'Specify the list of possible dishes'
    zero_data:
      title: 'No combos created'
      caption: 'Add combos to give your customers the opportunity to create unique combinations of dishes. An example of a combo could be a business lunch.'
    buttons:
      add: 'Add'
      edit: 'Edit'
    help: 'Combos are a convenient way to create a set of dishes that perfectly complement each other. For example, you can create a business lunch by selecting your favorite soup, salad, and main course, or order a set of 5 pizzas with a variety of flavors for a group.
          <br>
          <br>
          Combos allow you to create personalized solutions that suit any taste and occasion.'


  modifier_groups:
    zero_data:
      title: 'No configurations yet'
      caption: 'Configuration will allow customer to choose dish options. For example, a choice of sauce, additive, or serving size'
    buttons:
      add: 'Add '
      edit: 'Edit '

    condition:
      minmax: 'Requirement for quantity '
      view_type: 'Display as'
      prompt: 'Incentive'

    title: 'Configuring modifiers'


  delivery:
    menu:
      couriers: 'Couriers'
      zones: 'Delivery zones'
      own_couriers: 'Own couriers'

    outsource:
      statuses:
        canceled: 'Canceled'
        idle: 'No claim'
        claim_created: 'Courier search'
        courier_assigned: 'Courier assigned'
        delivering: 'Delivery in'
        delivered: 'Delivered'
        problem: 'Problem'
        pickup_arrived: 'The courier has arrived'

    zone:
      providers:
        own: 'No'
        dostavista: 'Dostavista'
        yandex_go: 'Yandex.Go'
        broniboy: 'Broniboy'
        dc_last_mile: 'DC Last Mile'
        sber_last_mile: 'Sber Last Mile'

    notifications:
      ymaps:
        title: 'Yandex Maps'
        message: 'Yandex token is blocked or unavailable'


  restaurants:
    tarif_restriction:
      title: 'Restaurant limit exceeded'
      message: 'Change tariff plan or disable out-of-date establishments'

    add_restaurant: 'Add restaurant '

    no_group: 'No grouping '

    remove_button: 'Delete '
    cancel_button: 'Cancel '
    save_button: 'Save '

    remove_confirm: 'Delete a restaurant?'
    cancel_confirm: 'Cancel changes?'

    validate_name_phone_address: 'Name, phone number and address must not be empty!'

    zero_data:
      message: 'No restaurant selected'
      hint: 'Please select a restaurant to view details or start editing.'

    edit:
      is_new: 'Adding a new restaurant'
      form_title: 'Fill out the form below and click save'
      normal_mode_text: 'Normal mode is enabled'
      normal_mode_caption: 'The default settings from the delivery area will be used'
      not_running: 'The establishment is not working'
      not_running_caption: 'Enable to start accepting orders for this establishment. '
      common_destroy: 'Common deletion'
      common_destroy_caption: 'Enable to forcibly delete the restaurant.'
      force_destroy: '⚠️ Forced deletion ⚠️'
      force_destroy_caption: 'Please note, in case of forced deletion, all orders and delivery zones related to this restaurant will also be deleted.<br>
                              Without the possibility of recovery!'
      timezone_caption: '⚠️ The organization has set {{timezone}}'
      off_reason_caption: 'In this field, you can specify the reason for disabling the restaurant'
      auto_enable_timezone: 'When the specified time comes, taking orders for this restaurant will be automatically enabled, and managers will be notified by email. '
      labels:
        name: 'Name'
        phone: 'Phone'
        address: 'Address'
        city: 'City'
        description: 'Description '
        availability: 'Order availability '
        rush_mode: 'High demand mode '
        is_delivery: 'Opening hours'
        deletion: 'Deletion'
        location: 'Map location '
        timezone:' Restaurant time zone '
        external_id:' External code '
        terminal_id: 'Terminal ID'
        order_number_prefix: 'Order number prefix'
        off_reason: 'Reason for disabling '
        auto_enable: 'When to automatically enable the restaurant '
        address_comment: 'Comment to the address '
        parent_restaurant: 'Parent restaurant'
        timetables: 'Operating Hours'

      placeholders:
        name: 'Enter the name'
        phone: 'Enter the number phone number '
        address: 'Enter the street name '
        city: 'Enter the city '
        location: 'If you need an explanation of the address (used when integrating with delivery outsourcing) '
        timezone: 'Time zone of the restaurant '
        external_id: 'Needed for integration with external services'
        terminal_id: 'Needed for integration with external services'
        order_number_prefix: 'Overriding the prefix for an order'
        off_reason : 'Specify the reason'
        description: 'Description for the restaurant page in the application and on the website'
        address_comment: 'If you need an explanation of the address (used when integrating with delivery outsourcing)'

      is_running: 'The restaurant is running'
      is_running_caption: 'Disable to stop accepting orders to this establishment.
                          disabled restaurants do not count towards tariff restrictions. '
      rush_mode_text: '🔥 High demand mode is enabled'
      rush_mode_caption: 'Special settings for this mode from the delivery zone will be used'

      default_for_city_text: 'Select by default'
      default_for_city_caption: 'This restaurant will be selected by default when choosing a city'

      is_delivery_text: 'Show address to customers'
      is_delivery_hint: 'Disable this feature if the restaurant only works for delivery and customers do not need to know its address ...
                          in this case, you will see the establishment on the map, and customers will only see the phone number. '

  organizations:
    add_button: 'Add organization'
    delete_button: 'Delete'
    cancel_button: 'Cancel'
    save_button: 'Save'
    add_button: 'Add'

    validate_name_host: 'The name and host must not be empty!'
    cancel_confirm: 'Cancel changes?'
    remove_confirm: 'Remove organization?'

    zero_data:
      message: 'No organization selected'
      hint: 'Select an organization to view details or start editing.'
    name:
      label: 'Name'
      placeholder: 'Enter'

    phone:
      label: 'Phone'
      placeholder: 'Enter phone number'

    host:
      label: 'Domain'
      placeholder: 'Enter subdomain * .smartomato.ru'

    login:
      label: 'Enter login '
      placeholder: 'Login '

    password:
      label: 'Password '
      placeholder: 'Enter password '

    about:
      label: 'Description '
      placeholder: 'Description '

  zone_templates:
    header: 'Add delivery condition to '

    switch:
      delivery: 'Delivery'
      takeaway: 'Pickup'
      dine_in: 'Dine-in'

    new_object_default_name:
      dine_in: 'Dine-in conditions'
      delivery: 'New delivery zone'
      takeaway: 'Takeaway point'

    header_description: 'You can add courier delivery zones orpoints'
    draw_description: 'If none of the predefined zones suits you, you can draw your own '
    draw_description_no_templates: 'Use the map to define the delivery area'
    draw_button: 'Draw zone '
    choose_zone_header: 'Use one of the templates '
    choose_zone_placeholder: 'Search '
    nothing_found: 'Zone not found '
    draw_zone_header: 'Draw a zone on the map '
    add_takeaway: 'Create a point '
    takeaway_note: 'To create a pickup point in this For a restaurant, you need to set operating conditions such as minimum order, item opening hours and cooking times. '
    dine_in_note: 'To enable dine-in in this restaurant you should set the conditions: the restaurant\'s working hours and some other parameters'
    add_dine_in: 'Add dine-in conditions'


  orders_map:
    no_current:
      title: 'No current orders'
      text: 'New orders or orders that require processing will go here'
    no_delayed:
      title: 'There are no pending orders'
      text: 'Orders that do not require your intervention yet will go here'

    courier_popup:
      statuses:
        offline:          'Off duty'
        free:             'Free'
        delivering:       'Delivering order to <strong>{{address}}</strong>'
        picking_up_order: 'On their way to pick up an order at <strong>{{restaurant}}</strong>'

  history:
    change_name :
      delivery_price: 'Delivery cost'
      delivery_at: 'Delivery time'
      cooking_start_at: 'Start of preparation'
      status: 'Status'
      courier_id: 'Courier'
      pick_up_at: 'Pickup time'
      contact_name: 'Name'
      contact_phone: 'Phone number'

  import:
    status:
      free : 'Free'
      upload: 'Downloading'
      queued: 'Queued'
      working: 'Running'

  modifier_group:
    new_group: 'New modifier group'
    edit:
      back_button: 'Back'
      header: ''
      subheader: 'Modifier group'
      photo:
        label: "Modifier Photo"
        upload: "Upload Photo"
      name:
        label: 'Title'
        placeholder: 'Title modifier groups '
      visible:
        label: 'Display '
      prompt:
        label: 'Suggestion for use '
        placeholder: 'For example, \'Pick doneness\' '
      minmax:
        label: 'Limit quantity '
      min:
        label: 'At least '
        placeholder: '-'
      max:
        label: 'At most '
        placeholder: '-'
      view_type:
        label: 'How to display '
        checkbox: 'Checkbox '
        select: 'Select '
        stepper: 'Stepper '
      external_id:
        label: 'External ID'
        placeholder: 'ID'
      modifiers:
        new_modifier: 'New modifier'
        restaurant_price: 'Price in {{restaurant}} ({{priceUnit}}) '
        header: 'Modifier set '
        comment: 'Specify a list of possible options'
        default: 'Default'
        name:
          label: 'Name'
          placeholder: 'For example, "Medium rare"'
        price:
          label: 'Price'
          placeholder: '-'
        external_id:
          label: 'External id'
          placeholder: '-'

      buttons:
        save: 'Save'
        delete: 'Delete'
        cancel: 'Cancel'
        add: 'Add modifier'

    availability:
      title: 'Availability of modifiers in the restaurant'
      caption: 'Here you can hide the modifier from the restaurant menu'
      loading: 'Loading'

  general_parameters:
    labels:
      site_name: 'The site is available at'
      site_name_caption: 'You can change the site address in the Organization settings section'
      organization_logo: 'Logo'
      organization_name: 'Organization name'
      organization_about: 'Organization description'

  static_pages:
    header: 'Page list'
    zero_data:
      search: 'No available pages'
    table:
      content:
        name: 'Title'
        slug: 'URL'
        position: 'Position'
        show_in_app: 'Displayed in App'
        show_in_web: 'Displayed on Website'
        page_type: 'Page Type'
      types:
        html: 'HTML'
        collection: 'Collection'
      filters:
        visibility: 'Visibility'
    edit:
      header: 'Edit Page'
      subheader: 'Fill out the form below and click save, please'
      photo:
        label: 'Фото дочерней страницы'
        placholder: 'Фото дочерней страницы'
      title:
        label: 'Название'
        placeholder: 'Название дочерней страницы'
      excerpt:
        label: 'Краткое описание'
        placeholder: 'Краткое описание дочерней страницы'
      name:
        label: 'Title'
        placeholder: 'Page Title'
      slug:
        label: 'Path'
        placeholder: 'Page Path'
      position:
        label: 'Display Order'
        placeholder: 'Display Order'
      content:
        label: 'Page Content'
      parent:
        label: 'Parent Page'
        placeholder: 'Select a Parent Page'
      childs:
        label: 'Child Pages'
        placeholder: 'Select Nested Pages'


  promos:
    table:
      content:
        name: 'Name'
        is_working: 'Active'
        actual_till: 'Validity Period'
        restaraunt: 'Restaurants'
        sources: 'Sources'
        priority: 'Priority'
        visibility: 'Visibility'
      filters:
        is_active:
          label: 'Active'
          active: 'Yes'
          not_active: 'No'
        date_range: 'Promotion Validity Period'
    confirm:
      delete: 'Delete promo?'

    buttons:
      add: 'Add'

    zero_data:
      active: 'No active promos yet'
      archive: 'No archive promos yet'
    zero_data_caption:
      active: 'Add promos to increase revenue and recurrence'
      archive: 'Add promos to increase revenue and recurrence'

    edit:
      back_button: 'Back'
      header: 'Editing the promotion'
      subheader: 'Fill out the form below and click save, please'

      menu:
        main: 'Total information'
        conditions: 'Conditions'
        bonuses: 'Bonuses'

      name:
        label: 'Title'
        placeholder: 'Name of the promotion'
      description:
        label : 'Description'
        placeholder: 'Description'
      offer_description:
        label: 'Offer to use'
        placeholder: 'The text that will be visible to the client if the action is available'
      is_working:
        label: 'The action is active'
        caption: 'Allows you to temporarily disable the action. Inactive promotions will not be shown to customers. '
      period:
        label: 'Expiration date'
        to: 'to'
      for_birthday:
        label: 'Birthday promotion'
        before_birthday: 'Active before birthday'
        after_birthday: 'Active after birthday'
        placeholder: 'number of days'
        caption: 'The birthday promotion can be activated a specified number of days before and after the birthday'
      timetable:
        enabled: 'Schedule enabled'
        disabled: 'Schedule disabled'
      timetable_for_order_time:
        label: 'Consider the time of the order'
        caption: 'The schedule will be applied to the time the order is placed, not to the delivery time'
      timetable_for_asap_only:
        label: 'Consider order time for ASAP orders only'
        caption: 'In case of a pending order, the time at which the order is placed will be used instead of the time it is placed'
      priority:
        label: 'Priority of the action'
        placeholder: 'positive integer'
        caption: 'The priority is needed to control the theme how the promotions will be summed up. <br> If several promotions suit the guest, one or more with the highest priority will be selected. '
      is_exclusive:
        label: 'Promo is mutually exclusive'
        caption: 'Allows you to prohibit the use of multiple promotions with the same priority in one order.'
      sources:
        label: 'Restriction on order sources'
        unrestricted: 'The promotion applies to all order sources'
        restricted_header: 'Pay attention!'
        restricted_comment: 'Due to restrictions on order sources, the promotion will only be available to customers when ordering from the sources listed'
      restaurants:
        label: 'Restricted restaurants'
        unrestricted: 'The promotion will work for all restaurants'
        restricted_header: 'Pay attention!'
        restricted_comment: 'Due to the restriction on restaurants, the customer will receive the promotion only after defining the restaurant (after entering the address or choosing the pick-up point)'
      inversed_delay: 'Off by default'
      disposable: 'Disposable'
      for_referral: 'For referral'
      is_takeaway: 'Suitable for takeaway'
      is_delivery: 'Suitable for delivery'
      is_dine_in: 'Suitable for dine in'
      free_delivery: 'Free delivery'
      not_delivery_takeaway_warning: 'For the promotion to work, it must be suitable for at least one way of receiving an order '
      disable_bonus_getting: "Do not accumulate points"
      disable_bonus_usage: "Do not redeem points"
      last_order:
        header: 'Past orders'
        comment: 'You can make a promotion that will check past orders of guests, for example, at least one order in the last N days or the number of orders before the current one'
        days_count:
          label: 'Number of days:'
          placeholder: 'Number of days:'
          caption: 'There was at least one order for the specified number of days'
        sum:
          label: 'Minimum order amount:'
          placeholder: 'Amount'
      single_use_codes:
        header: 'One-time promotional codes'
        comment: 'In a promotion, you can define a set of codes that will include it. Each code can only be used once. '
        enabled:
          label: 'One-time codes'
          caption: 'A set of secret codes can be generated, each of which can be used only once '
        stat:
          label: 'The number of codes added to the action '
          report: 'Report on the use of codes'
          download: 'Download codes (.csv) '
          used: 'Used of them '
          available: 'Available for use '
          delete_unused: 'Delete unused codes '
        create:
          title: 'Generate promotional codes '
          title_more: 'Generate additional promotional codes '
          amount: 'Amount '
          length: 'Code length '
          button: 'Generate '
          comment: 'You can immediately create a group of codes according to certain rules,
            specify how many codes you need and how many characters they should be in length.
            the more characters, the less likely the client will be able to pick them up, but the more difficult it is to enter them. '
          generate: 'Generate codes'
          cancel: 'Do not generate codes'
          need_save: 'Generation will be available after saving the promotion'
      promos_issue:
        header: 'Manual and automatic issuance of codes to customers'
        comment: 'Enable to configure this promotion so that customers can be send codes to access it '
        enable:
          label: 'Enable the issuance of codes with sms notification '
        issue_sms_text:
          label: 'Text of sms message '
          placeholder: 'Text '
          example:
            label: 'For example: '
            text: '[name] , as an excuse for being late in the delivery of your order, we want to give you a pizza, please indicate the [code] code in the next order '
        length:
          label: 'Code length '
          placeholder: 'number of characters '
          caption: 'The more characters, the lower the probability that the client can pick them up, but the more difficult it is to enter them. '
        ttl:
          label: 'Lifetime of each code, days'
          placeholder: 'days'
          caption: 'After the specified number of days, the code will be removed. <br> 0 - never remove codes.'
        manual_enable: 'Allow manual issuance of codes to clients'
      issue_late:
        header: 'Bonuses for being late'
        comment: 'You can set up this promotion so that for each order delivered late, an SMS with a one-time code from this promotion is sent to the client'
        enable:
          label : 'Enable late bonuses'
        minutes_amount:
          label: 'Consider delay more than, min:'
          placeholder: 'min.'
      codes:
        header: 'Reusable promotional codes'
        comment: 'You can set a code that will enable the promotion.'
        code:
          label: 'Reusable promotional code'
          placeholder: 'Secret code'
          caption: 'If you set a promo code for a promotion, then guests will bewhen placing an order
            able to specify a code. The code can be combined with other conditions of the promotion. Any number of orders can be made with this code. '
      error_text:
        label: 'Error text for the guest'
        placeholder: 'Error text for the guest'
        caption: 'If the guest specifies the correct code, but the promotion does not match the criteria, he will be shown the specified text.'
      required_all_dishes:
        header: 'All specified dishes are included in the order'
        comment: 'For example, a free drink when ordering Chicken Burger, French fries and Cole Slow salad'
        label: 'List of dishes'
      required_any_dish:
        header: 'The presence of one or more in the order dishes from the specified list '
        comment: 'For example, a free drink when ordering four pizzas with meat, pepperoni or mushrooms'
        label: 'List of dishes'
        number: 'Quantity from the list of dishes'
      required_any_dish_categories:
        label: 'List of categories'
      client_requirements:
        header: 'Client requirements'
        category:
          label: 'Customer categories'
          caption: 'the customer must belong to one of the specified categories'
        restrict_category:
          label: 'Deny certain customer categories'
          caption: 'The customer must not have any of the listed categories'
        recurrence:
          label: 'Customer recurrence'
          caption: 'The customer must have one of the specified recurrence type'
        order_sum:
          label: 'Order amount'
          warning: 'You must set the order amount'
        count_order_sum_with_delivery:
          label: 'Include delivery cost'
        repeatable_bonus:
          label : 'May fire several times in one order'
          caption: 'For example, <em> "give a free drink for each burger in the order" </em>'
        for_new_client:
          label: 'Promotion for a new client'
          caption: 'Promotion triggered This is for a customer who has not had any orders yet'
        nth_order:
          label: 'Order number '
          caption: 'allows you to set a discount for each N-th order of the customer, orders are counted during the period of the promotion, you can set a minimum order amount that needs to be counted'
      bonuses:
        header: 'Bonuses'
        comment: 'Determine the result of applying the promotion in the order'
        bonus_dishes:
          label: 'Add the specified dishes to the order'
        bonus_price:
          label: 'The cost of bonus dishes'
          caption: 'If you want to give gift dishes at a special price, not free'
        bonus_free_dishes:
          label: 'Offer to choose one of the specified dishes'
        discount_percent:
          label: 'Percentage discount on order '
        discount_fixed:
          label: 'Fixed discount on order '
        discount_dishes_percent:
          label: 'Percentage discount on dishes specified in conditions'
          caption: 'Allows you to set a discount on specific meals only, not on the entire order. '
          single_dish: 'only for one dish from the list'
          cheapest:
            caption: 'By default, the discount will go to the dish with the highest price. But that can be changed. '
            enable: 'give a discount on the cheapest dish'
        assign_tag:
          label: 'Assign a category to the user'
        reset_tag:
          label: 'Reset the specified categories for the client, if any'
        issue_code:
          label: 'Create and send a code from the promotion'
      buttons:
        save: 'Save'
        delete: 'Delete'
        cancel: 'Cancel'



    add_promo: 'Add promotion'

    headers:
      index: 'List of shares'
      active:' Active shares'
      archived: 'Archive of the promotion'
      view_variant:
        cards: 'Cards'
        table: 'Table'
        label: 'Display Option'


    during_last_days:
      one: 'Was at least 1 order in the last {{count}} day '
      few:' There was at least 1 order in the last {{count}} days '
      many:' There was at least 1 order in the last {{count}} days '
      other:' There was at least 1 order in the last {{count}} days '

  promo_card:
    buttons:
      edit: 'edit '
    condition:
      dish_discount: 'Discount for promotional dishes '
      next_order_in_days: 'Bonus for the last order: '
      next_order_min_sum: ' with total not less than '
      actual_from: 'Dates: '
      restaurants_selected: 'Restaurants : '
      restaurants_all: 'All restaurants '
      promo_code: 'Promo code: '
      it_free: 'Present'
      order_discount: 'Discount on order '
      actual_till: 'Promotion ended: '
      copy: 'Copy link'
      copied: 'Link copied'

  banners_index:
    header: 'Showcase banners and app'
    create_button: 'Add'
    zero_data:
      header: 'You don\'t have banners yet'
      caption: 'You can use banners to tell your guests some information on the website or in the mobile app'
  banners:
    disabled_text: 'Sorry, you cannot use the <br>banners feature'
    back_button: 'Back'
    title: 'Edit banner'
    main:
      name:
        label: 'title'
        placeholder: 'Banner title (for internal use)'
      view_order:
        label: 'Display order: '
        placeholder: 'Numerical order (1, 2, 3...)'
        zero: 'not set'
      url_web: 'Link for storefront'
      url_mobile: 'Link for app'
      platform:
        label: 'Where to display the banner: '
        placeholder: 'Choose platform'
        web: 'In storefront'
        mobile_web: 'On display (mobile version)'
        mobile: 'In App'
        zero: 'not set'
      photo:
        label: 'Picture'
        storyLabel: 'Story Preview'
      restaurants:
        label: 'Restriction on restaurants'
      is_archived:
        label: 'Hide banner'
      terms:
        label: 'expiry date'
        to: 'till'
      story_frames:
        label: 'Story Frames'
        create_frame: 'Add'
      has_clickable_popup: 'Clickable popup'
      has_popup_on_start: 'Popup at start'
      popup_with_image:   'Popup with image'
      popup_is_blocking: 'Blocking popup'
      popup_title: 'Popup title'
      popup_content: 'Popup text'
      cancel_button: 'Text for cancel button'
      confirm_button: 'Text for confirm button'
      story_title: 'Story Title'
      type:
        title: 'Content Type'
        link: 'Link'
        popup: 'Popup'
        story: 'Story'
  adverts_index:
    header: 'Advertisements and newsletters '
    create_button: 'Add '
    is_private: 'hidden '
    zero_data:
      header: 'You have no ads yet '
      caption: 'You can use ads to inform guests: on the website, by push-message or in some other way '
  adverts:
    tabs:
      table: 'Table'
      cards: 'Cards'
    table:
      content:
        name: 'Name'
        recurrence: 'Recurrence Restriction'
        client_tags: 'Client Categories'
        restaurants: 'Restaurants'
        channels: 'Channel Types'
        created_at: 'Creation Date'
    disabled_text: 'Unfortunately, the functionality of advertisements is not available to you '
    back_button: 'Back '
    title: 'Editing an ad '
    menu:
      main: 'General data '
      preview: 'View '
      delivery: 'Mailing list '
      stats: 'Statistics '
    main:
      name:
        label: 'Title '
        placeholder: 'Ad title '
      text:
        label: 'Text '
        placeholder: 'Long text '
      action:
        label: 'Link -action '
        placeholder: 'Link from the button '
      photo:
        label: 'Picture '
      is_private:
        label: 'Non-public action '
        on_comment: 'Now this ad will be visible only by direct link sent to'
        off_comment: 'Now this ad will be displayed to everyone upon entering the site or application '
      is_archived:
        label: 'Hide ad '
      terms:
        label: 'Expiration date'
        to: 'before '
    preview:
      link: 'Link to ad: '
    delivery:
      intro: 'To launch mailing list select the customers to whom this advertisement should be sent. <br> Mailing list can be carried out immediately via SMS or first try via push notification, and only then via sms. '
      restaurants:
        label: 'Restricted by restaurants'
        placeholder: 'Do not restrict by restaurants'
      recurrence:
        label: 'Restricted by return'
        placeholder: 'All'
      were_orders:
        label: 'There was at least one order in the period'
        from: 'from'
        to : 'by'
      were_no_orders:
        label: 'There were no orders in the period'
        not_yet: 'This criterion does not work yet'
        from: 'from'
        to: 'to'
      send_push:
        label: 'Push notification'
        caption: 'Push- notification in iOS and Android applications '
      send_sms:
        label: 'SMS '
        caption: ''
      send_whatsapp:
        label: 'WhatsApp'
        caption: 'Message on WhatsApp'
      text_sms:
        label: 'SMS text message '
        placeholder: 'SMS text '
        caption: 'To place a link in the text, indicate it in a separate field on this form, and use <code> {link} </code> in the template itself.
          then, at the time of mailing, a link, unique for each recipient, will be generated instead.
          this will help us calculate email conversion rates.
          <br> To insert a client\'s name into a message, use the [name] construction.'
      push_text:
        label: 'Push notification text'
        placeholder: 'Push notification text'
        caption: 'You don\'t need to use links in the text, but you can use emoji 😉'
        error_text: 'Push notification text length must not exceed 260 characters'
      push_title:
        label: 'Push notification title'
        placeholder: 'Push notification title'
        caption: 'Leave blank to use the application name as the title.<br>We recommend setting a maximum of 65 characters'
      link:
        label: 'Link'
        placeholder: 'Push notification text'
        caption: 'If you want the ad itself to be displayed to the client when entering the site, add the following code at the end:'
        notice: 'the link will be shortened to reduce the number of sms and read conversion statistics'
      promo:
        label: 'Promotion, to calculate the conversion'
        no_promos: 'You don\'t have any stocks yet. Add a promotion with a promo code and indicate it here, this will help in calculating the conversion '
        caption: 'All orders made using the selected promotion will be counted as targeted in the statistics of this ad delivery '
      execution:
        status_label: 'Status: '
        counting: 'We are looking for clients by the specified criteria ... '
        found: 'The following criteria were found: '
        execute_button: 'Start the mailing '
      scheduled_at:
        label: 'Schedule an announcement'
      cancel:
        cancel_button: 'Cancel announcement'
    stats:
      header: 'Statistics of the completed mailing '
      loading: 'Loading statistics ... '
      transport: 'Delivery channel: '
      sent: 'Sent : '
      received: 'Received:'
      shown: 'Delivered (SMS):'
      opened: 'Opened:'
      orders_made: 'Orders made: '
      average_total: 'Average check: '
      sum_total: 'Total revenue: '
      income_per_sent: 'Revenue per ad: '

      empty_stat: 'There are no delivery statistics for this ad yet. '
      empty_promo:
        header: 'The ad does not targeted promotion - the conversion calculation will be inaccurate targeted'
        comment: '<p> The promotion helps the system to distinguish orders that customers have made for this ad. </p> < p> The conversion will take into account all orders in which the specified promotion was applied </p> '
  loyalties_index:
    header: 'Loyalty Programs'
    create_button: 'Add'
    zero_data:
      header: 'You currently have no loyalty programs'
      caption: 'Loyalty programs allow you to attract and retain customers with rewards such as discounts or bonuses.'
  loyalties:
    new: 'Loyalty Program'
    disabled_text: 'Unfortunately, the loyalty programs functionality is not available to you.'
    back_button: 'Back'
    title: 'Edit Loyalty Program'
    main:
      name:
        label: 'Name'
        placeholder: 'Name'
      kind:
        label: 'Loyalty Program Type: '
        zero: 'Not Specified'
  bonus_categories_index:
    header: 'Bonus categories'
    create_button: 'Add'
    zero_data:
      header: 'You don\'t have any bonus categories yet'
  bonus_category:
    new: 'Bonus category'
    disabled_text: 'Unfortunately, the functionality of <br>bonus categories is not available to you'
    back_button: 'Back'
    title: 'Editing a bonus category'
    main:
      name:
        label: 'Name'
        placeholder: 'Name'
      is_working:
        label: 'Category active'
      color:
        label: 'Category color'
      sum_period:
        label: 'What period to consider when summing up orders'
        placeholder: 'in days'
      sum_upper_bound:
        label: 'Upper limit on the amount of orders for a category'
      bonus_percent:
        label: 'Percentage of accrued bonuses per order'
      expense_percent:
        label: 'Bonus Deduction Percentage'
      external_id:
        label: 'External id'
  client_tags_index:
    header: 'Tags'
    create_button: 'Add'
    zero_data:
      header: 'You don\'t have any tags yet'
  client_tag:
    new: 'Tag'
    disabled_text: 'Sorry, you don\'t have access to the tag functionality'
    back_button: 'Back'
    title: 'Edit tag'
    main:
      name:
        label: 'Name'
        placeholder: 'Name'
      assign_type:
        label: 'If the conditions are met'
        autoassign: 'Assign'
        autounassign: 'Unassign'
      period:
        label: 'Tracking period'
        from: 'from'
        to: 'to'
      num_of_orders: 'Number of orders per period'
      spended_sum: 'Revenue by client for the period'
      order_frequency: 'Frequency of orders for the period'
      consumed_category:
        label: 'Ordering dishes from a specific category'
        non_label: 'Lack of orders from a certain category'
      consumed_dish:
        label: 'Order a specific dish'
        non_label: 'Lack of orders for a specific dish'
      tags_to_unassign:
        label: 'Remove Tags'
      applicable_to_all: 'Apply to past data'

  communication_channels:
    incoming: 'Incoming message'
    auth: 'Show QR Code'
    header: 'Communication Channels'
    columns:
      kind: 'Channel Type'
      status: 'Status'
    kinds:
      whatsapp: 'WhatsApp'
      telegram: 'Telegram'
      push: 'Push Notifications'
      sms: 'SMS'
      vk: 'VKontakte'
    status:
      active: 'Enabled'
      enabled: 'Enabled'
      disabled: 'Disabled'
      error: 'Error'
    edit:
      priority: 'Priority'
      enabled:
        true: 'Channel is active'
        false: 'Channel is disabled'
    chats:
      can_send: 'Enter a message'
      disabled: 'No available channels'


  courier:
    new: 'New courier'
    confirms:
      delete: 'Delete courier?'
    alerts:
      success:
        title: 'Saved'
        message: 'Courier successfully saved.'
      delete:
        title: 'Deleted!'
        message: 'Courier deleted.'
      error:
        title: 'Error!'
    add:
      courier_list: 'List of couriers '
      add_button: 'Add '

    availability_everywhere: 'The courier is available in all restaurants'

    edit:
      buttons:
        back: 'Back '
        assign: 'Assign'
        cancel_assigment: 'Cancel the assignment'
        cancel_order_in: 'Cancel order in'
        create_an_app_in: 'Create an application in'

      labels:
        avatar: 'Photo '
        name: 'Name '
        phone: 'Phone'
        login: 'Email'
        password: 'password'
        repeat_password: 'Confirm password'
        courier_status: 'Blocked / Dismissed'
        select_restaurant: 'Restaurant restrictions'
        courier_comment: 'Comment'

      placeholders:
        name: 'Enter'
        phone: 'the phone number'
        email: 'Enter email'
        password: 'Enter password'
        repeat_password: 'Confirm password'
        courier_status: 'Blocked / Fired'
        select_restaurant: 'Restriction on restaurants'
        courier_comment: 'Comment '

      toggle:
        text: 'Block access to Smartomato '
        caption: 'This will save the account, but deny access to Smartomato '

      caption:
        download_courier_app:
          text: 'Login and password are required to enter the courier app. Download courier app '
          ios: 'for iOS '
          android: ' or Android '
          and: 'and '

      is_edit: 'Editing courier '
      is_new: 'Add new courier '
      form_edit_title: 'Fill out the form below and click save '
      courier_availability_about: 'This will help manager to see only suitable couriers while assigning them to orders'

      transport_type:
        label: 'Courier Transport Type'
        about: 'The method of transportation the courier uses for deliveries'
        types:
          public_transport: 'By public transport'
          walk: 'On foot'
          car: 'By car'

    buttons:
      save: 'Save '
      cancel: 'Cancel '
      delete: 'Delete '

  delivery_zone:
    labels:
      color: 'Zone fill color'
      dine_in_name: 'Dine-in settings name'
      takeaway_name: 'Name of the point '
      minimal_order_price: 'Min. order ({{unit}}) '
      free_delivery_price: 'Free from ({{unit}}) '
      cooking_time: 'Cooking time (min.) '
      cooking_time_auto: 'Automatic cooking time calculation'
      delivery_zone_priority: 'Zone priority '
      courier_order_fee: 'Courier fee for delivering an order in this zone: '
      delivery_time_expand_minutes: 'Extend the normal working time by (min.) '
      delivery_zone_name: 'Zone name '
      delivery_price: 'Delivery price ({{unit}}) '
      delivery_time: 'Total delivery time (min.) '
      transportation_time: 'Transportation time (min.) '
      outsource_provider: 'Outsource delivery: '
      outsource_subsidy: 'Subsidize delivery to: '
      outsource_reject_from_price: 'Prohibit delivery at price from: '
      outsource_free_delivery_price: 'Free delivery price form:'
      service_charge: 'Service charge (%):'
      fixed_service_charge: 'Fixed service charge'
      delivery_zone_edit: 'Mark the delivery zone area on the map:'
      special_condition_comment: 'Comment on special delivery condition'
    placeholders:
      no_outsource_provider: 'No '
    segments:
      settings: 'Settings '
      advanced: 'Advanced '
      timetable: 'Schedule '
    buttons:
      delete: 'Delete '
      save: 'Save '
      area_edit: 'Edit area '
      area_define: 'Mark delivery area'
    validation:
      no_time_intervals: 'Set all time checkpoints for logistics properly work'
      time_not_valid: 'The total delivery time must be greater than the sum of the preparation time and the transportation time'
    popover:
      help_timetable_text: '<p> The work schedule allows you to set the time for which the system will allow placing orders. </p>
                            <p> At the specified time, couriers will deliver the last order and complete work. </p> <p> The kitchen will be vacated earlier in accordance with the delivery time ,
                            indicated th in the zone settings. </p> <br>
                            <p> ⚠️ & nbsp; It is not the operating mode of the restaurant that is set, but the time when the order can be delivered. </p>
                            <p> For example, if the restaurant is open until 22:00 and delivery takes 1 hour, then you need to indicate the end of delivery at 23:00.
                            in fact, in the restrictions, you set the time of receipt of the order. </p> <p> Similarly, if the restaurant opens at 10:00 and the same hour on the road,
                            then at the beginning of the delivery you need to specify 11:00. </p> '
      help_delivery_process:'<p>Smartomato\'s ideology of order processing consists of several stages: </p>
                            <ol> <li> Confirmation and approval of the order </li>
                            <li> Sending an order to the kitchen </li>
                            <li> Preparing and completing the order </li>
                            <li> Pick up order by courier </li>
                            <li> Order transportation </li>
                            <li> Order delivering to the client </li> </ol>

                            <p> In order for our system to calculate all intermediate stages of delivery and
                            monitor deviations, set the preparation time, transportation and total delivery time.</p>

                            <p>The total delivery time should not be less than the sum of the cooking and transportation times, but
                                may exceed it if it implies a lengthy process of approval or other organizational procedures prior
                                to the start of preparation.</p> </div>'

      help_priority_text:' <p> You can define several delivery conditions that partially or completely overlap in the delivery area. </p>
                          <p> These zones can be linked to one restaurant or to different ones. < / p>
                          <p> The selection of a suitable zone will be performed according to the following principle. </p>
                          <ol>
                            <li> First, Smartomato will define zones that include the client\'s address </li>
                            <li> Then zones that are suitable in time will be selected work </li>
                            <li> After that, zones will be selected that match the size of the minimum order </li>
                          </ol>
                          <p> If several zones are still suitable, Smartomato will search for the most suitable one: </p>
                          <ol >
                            <li> A zone with a higher priority will be selected first (higher number - higher priority) </li>
                            <li> If there are several with the same priority, then the zone with the lowest delivery price / lowest minimum order / lowest delivery time will be found < / li>
                            <li> If there are several of them, then dynamic distribution will work, taking into account the current load: </li>
                          </ol>
                          <p> With dynamic allocation, a zone will be selected that is tied to a restaurant with a smaller number of active orders at the current moment - thus, if several restaurants serve the same address, they will be loaded evenly. </p> '
      help_advanced_courier_text: '<p> If you define the courier\'s fee for an order, then in the reports on orders, when grouped by courier, you will be able to see the amount for orders delivered by the courier. </p>
                                    <p> ⚠️ Pay attention that all orders, even canceled ones, are summed up. we do not know the payment policy of your company.
                                    to correct the data in the report, you can filter orders by status. </p> '
      help_rush_mode_text: '<p> This mode will allow restaurant managers to switch to a longer or more expensive delivery when they have too many orders or some other force majeure. </p>
                          <p> You can leave some of the fields empty, then in case of "high demand" the corresponding parameter will not change. </p> '

    advanced_settings:
      title: 'Advanced settings'
      advanced_courier:
        title: 'Settlements by courier'
      rush_settings:
        title: 'Parameters for "high demand" mode'
    timetable_title: 'Time for taking orders'
    add_takeaway_or_delivery: 'Add zone or'
    is_takeaway: 'Pickup options'
    is_delivery: 'Delivery options'
    is_dine_in: 'Dine-in options'

  settings:
    analytics:
      title: 'Meta tags'
      sub_title : 'The data from these tags is used by search engines and social networks to generate an advertisement for the page'
      meta_title_caption: 'Will also be used as & lt; title & gt; pages'
      buttons:
        load_meta_image: 'Load Meta Image'
        save: 'Save'
        cancel: 'Cancel'
      placeholders:
        services:
          identificator: 'Identifier'
      labels:
        meta_title: 'Meta Title'
        meta_description: 'Meta Description'
        meta_image: 'Meta image'
      services:
        title: 'Web analytics services'
        subtitle: 'The ability to connect web analytics services to the Smartomato storefront '
        feature_text: 'Smartomato can record the activity of your clients in statistics collection systems We record not only traffic, but also goals that will allow you to better understand your customers. Smartomato is also integrated with Google Analitycs Enhanced Ecommerce to measure the effectiveness of advertising campaigns. '
        labels:
          ga: 'Google Analytics'
          metrika: 'Yandex.Metrica '
          gtm: 'Google Tag Manager '
          fb_pixel : 'Facebook Pixel '
          vk_pixel: 'VK Pixel '
          mail_pixel: 'Mail.Ru Counter ID '
          data_layer: 'Enable e-commerce tracking in DataLayer '
        data_layer_caption: 'The widget will send information about the actions of guests to the DataLayer. '
        data_layer_more: 'More about DataLayer '
        examples:
          ga: 'For example: UA-61543473-1 '
          metrika: 'For example: 21277873 '
          gtm: 'For example: GTM-11XX1XX '
          fb_pixel: 'For example: 111111111111 (Numeric code of 12 or more digits) '
          vk_pixel: 'For example: VK-RTRG-111111-aA1A1 '
          mail_pixel: 'For example: 123456 '
        events:
          open:
            modal:
              order: 'Opened order window '
              receipt: 'Opened previous order '
              invite: 'Opened invitation dialog '
            configurator: 'Opened the big / small configurator'
            quick_configurator: 'and'
          copy_invite: 'Copied the link for the'
          dish_click: 'invitation Clicked on the dish'
          dish_add: 'Added the dish to the basket'
          show_delivery_zones: 'Opened the map with delivery zones'
          address_autodetect: 'Clicked to autodetect the address'
          click_pay: 'Clicked on the "pay"'
          order_paid: 'Order paid'
          buttonclick_checkout:
            event: 'Clicked on the "place an order" button'
            description:
              no_valid: 'The order has been created (there may be fewer of these events if the client has filled out the form incorrectly)'
              and: 'and'
    business_role:
      zero_data:
        title: 'No business roles have been added yet'
        caption: 'Add business roles for more precise access and business process management'
      list_business_role: 'List of business roles'
      add_new: 'Add'
      delete: 'Delete the business role?'
      cancel: 'Cancel the changes?'
      title:
        is_exist: 'Edit business role'
        is_new: 'Add new business role'
      subtitile: 'Accessing parts of the Smartomat system'
      labels:
        name: 'Role name'
        permitted_statuses: 'Permitted order statuses'
        privileges: 'Rights'
        subject: 'Subject'
        reports_access: 'Access to reports'
        can_assign_courier: 'Assigning couriers to orders'
      subject:
        table: 'Tables'
        courier: 'Couriers'
        organization: 'Organization'
        draft_dish: 'Dishes'
        draft_category: 'Categories'
        modifier_group: 'Modifier Groups'
        modifier: 'Modifiers'
        modifier_scheme: 'Scheme of modifiers in a dish'
        modifier_scheme_item: 'Groups in a modifier scheme'
        delivery_zone: 'Delivery zones'
        order: 'Orders'
        client: 'Guests'
        client_tag: 'Guests tags'
        staff_member: 'Employees'
        service: 'Fee plans'
        service_subscription: 'Subscription'
        invoice: 'Invoices'
        invoice_item: 'Invoice details'
        billing_info: 'billing'
        bank_details: 'Bank details'
        theme: 'Theme Templates'
        skin: 'Design theme'
        order_item: 'Order contents'
        buddy: 'Order takers'
        promo: 'Promotions'
        advert: 'Newsletter'
        banner: 'Banners'
        loyalty_program: 'Loyalty programmes'
        business_role: 'Business roles'
        cooking_line: 'Cooking rooms'
        payment: 'Payments'
        dish: 'Website/application meals (read only)'
        category: 'Website/Application categories (read only)'
        api_user: 'personal account'
        restaurant: 'Restaurants'
        brand: 'Brand'
        dish_group: 'Dish group'
        organization_common_file: 'Organization common file'
        static_page: 'Static page'
      actions:
        read: 'View'
        create: 'Create'
        update: 'Update'
        destroy: 'Delete'
        qr: 'Generate QR Code'
        publish: 'Publish'
        stats: 'Statistics'
        upload_logo: 'Uploading a logo'
        remove_logo: 'Remove logo'
        upload_favicon: 'Upload favicon'
        upload_meta_image: 'SEO images'
        import_menu: 'Import menu (API)'
        support_issue: 'Support_letters'
        check_host: 'Change domain'
        reorder: 'Sorting'
        upload_photo: 'Uploading a photo'
        upload_avatar: 'Upload avatar'
        update_priorities: 'Updating order priority'
        delay_bonus: 'Delay Bonus'
        status: 'Status'
        receipt: 'consignment note'
        geocode: 'Geocoding'
        reverse_geocode: 'Reverse geocoding'
        assign_zone: 'Define zone'
        confirm: 'Confirmation'
        set_client_sign: 'Client Signature'
        place: 'Place order'
        dispose: 'Write off'
        select_bonus_dish: 'Select gift'
        validate: 'Validate'
        logs: 'Logs'
        cancel_outsource: 'Cancel outsource'
        place_outsource: 'Outsource placement'
        bonus_log: 'Bonus history'
        commit_bonus_amount: 'Change bonuses'
        switch: 'Change of Subscription'
        detailed: 'Account details'
        configure: 'Customise'
        delete_photo: 'Delete photo'
        select: 'Change subject'
        create_promo_codes: 'Create promo codes'
        issue_promo_code: 'Issue promo codes'
        delete_unused_promo_codes: 'Delete promo codes'
        promo_codes_usage: 'Promo code statistics'
        clients_count: 'Number of guests'
        execute: 'Start newsletter'
        cancel: 'Cancel Newsletter'
        statistics: 'Newsletter statistics'
        stat: 'Account log'
        availability: 'Availability'
        checklist: 'Initial setup'
        menu: 'Menu'
        menu_export: 'Export menu'
        categories: 'Categories'
        dishes: 'Dishes'
        retry_pos_export: 'Retry pos export'
        rate_processed: 'Rate processed'
        unprocessed_counts: 'Unprocessed counts'
        reset: 'Reset'
        upload_file: 'Upload file'
        upload_story_photo: 'Uploading  story photo'
        reorder_story_frames: 'Reordering story frames'
        upload_static_page_photo: 'Uploading a photo'
        upload_static_page_section_photo: 'Upload section photo'
        reorder_static_page_sections: 'Reordering sections'
      placeholders:
        name: 'Role name'
        permitted_statuses: 'Permitted order statuses'
      staff_members_count: 'Staff members with this role: {{staffMembersCount}}'
    staff:
      list_staff: 'List of staff'
      add_new: 'Add'
      title:
        is_exist: 'Editing an employee'
        is_new: 'Adding a new employee'
      subtitile: 'Access of employees to the system, establishments and other Smartomato services'
      labels:
        staff_disabled: 'Disabled / Fired '
        staff_role: 'Employee role '
        avatar: 'Avatar '
        name: 'Name '
        phone: 'Phone '
        login: 'Email '
        password: 'Password '
        repeat_password: 'Confirmation '
        notifications: 'Notifications '
        connect_sip: 'Integrate SIP'
        sip_login: 'SIP address'
        sip_password: 'SIP password'
        restaurant: 'Restaurants'
        cooking_line: 'Resraurant cooking workshop'

      placeholders:
        name: 'Name '
        phone: 'Enter phone number '
        login: 'Enter email '
        password: 'Enter password '
        repeat_password: 'Confirm password '
      staff_disabled:
        text: 'Block access to Smartomato '
        caption: 'This will keep the account, but deny access to Smartomato '
      sip_enabled:
        title: 'Phone integration setup'
        text: 'announce new calls'
        caption: 'Integrate SIP-account to order management system?'
      staff_restaurants: 'Restaurants, available for the user'
      staff_cooking_lines: 'Resraurant workshops, available for the user'

      business_role:
        label: 'Business Role'
        caption: '⚠️ Attention: When selecting a business role, the employee will be given separate rights that are in no way related to the standard roles'
      staff_role:
        admin:
          title: 'Administrator '
          description: 'Full access to organization management '
        manager:
          title: 'Manager '
          description: 'Managing the availability of food in restaurants '
        manager_logist:
          title: 'Logistic manager '
          description: 'Managing customers, the full cycle of logistics and food availability '
        logist:
          title: 'Logist '
          description: 'Logis tick orders '
        regional_admin:
          title: 'Regional administrator (franchisee) '
          description: 'Can change specified restaurants and prices in them. Create employees in the specified restaurants. '
      notifications:
        name: 'Name'
      notification_url: 'for integration with API'
    sip:
      title: 'Telephony settings'
      explanation: '<p> Smartomato can integrate with IP telephony and greatly simplify the work of a telephone operator. </p>
                    <p> You will be able to find out who is calling the call center even before you pick up the phone. The name of the customer, their current order, history of past orders are all you need. </p> '
      disabled:
        before_link: 'There is no integration option in your tariff plan. You can '
        link: 'change the tariff plan '
        after_link: 'to enable telephony integration. '
      enabled:
        before_link: 'To configure the integration, you must select the employees who will receive calls in the\'section'
        link: 'Employees. '
        after_link: 'For each employee, you need to specify a sip-username and password in the "Telephony" section on the edit card. '
      staff_with_sip:
        title: 'At the moments incoming calls will be announced to:'
        go_to_staff: 'proceed to user call settings'


    organization:
      title: 'Organization settings'
      subtitle: 'Fill out the form below and click save, please '
      caption:
        id: 'ID may be needed for integration, in particular for <a href = "https://developer.smartomato.ru/ widget "> Widget placement </a> Smartomato on your site '
      labels:
        id: 'Organization ID '
        logo: 'Logo '
        name: 'Organization name '
        phone: 'Phone number '
        about: 'Description '
        hostname: 'Site address'
        advanced_head : 'Advanced settings of the Smartomato storefront'
        advanced_settings:
          head:
            caption:
              description: 'This code will be placed in the &lt;HEAD&gt; section of the page. Here you can specify arbitrary HTML, CSS or JavaScript (use the & lt; STYLE & gt and & lt; SCRIPT & gt tags). '
              warning: 'Attention!'
              ask_support_description_before: 'Code appears on the page without posting, be careful. Please contact'
              ask_support: 'support '
              ask_support_description_after: 'if you do not fully understand why this is all needed :) We will be happy to help. '
          body:
            caption:
              description: 'Similarly, but at the end of the page'
        advanced_body: 'Code to be placed at the end of the page'
        timezone: 'Time zone'
        is_published: 'Publication'
        vk: 'Vkontakte'
        whatsapp: 'WhatsApp'
      buttons:
        upload_logo: 'Upload logo'
        change_host: 'Edit'
        upload_favicon: 'Upload Favicon'
      is_published:
        text: 'Publish Restaurant'
        description: 'Is the restaurant available at the specified address?'
      placeholders:
        name: 'Name'
        phone: 'Enter phone number'
        about: 'Description of organization'
        advanced_head: 'Advanced site settings (section HEAD)'
        advanced_body: 'Advanced site settings (section BODY)'
      lang_settings_helper: 'If you need to change currency or the language settings of the organization - write to us in support and we will help. '

    host:
      title: 'Changing the domain name'
      subtitile: 'Selecting the address where the Smartomato storefront will be available'
      explanation:
        text: 'For the Smartomato storefront, you can use the address in the <b> * .smartomato.ru </b> zone or bind own domain. For an address like <b> restaurant_name.smartomato.ru </b>, just select any unoccupied address, and everything will work automatically! '
        before_link: 'It\'s a little more complicated when using your own URL, but we\'ll show you.'
        link: 'Email us'
        after_link: 'and we will try to help you as soon as possible.'

    integrations:
      title: 'Smartomato integrations'
      feature_text: 'Smartomato can interact with many services, write us and we will help you set up everything'
      feature:
        pos:
          title: 'Restaurant accounting'
          poster:
            title: 'Poster'
            description: 'Sending confirmed orders from Smartomato to the kitchen. Import menus and restaurants from Poster to Smartomato. '
          r_keeper:
            title: 'R-Keeper'
            description: 'Sending confirmed orders from Smartomato to the kitchen.'
          iiko:
            title: 'Iiko'
            description: 'Sending confirmed orders from Smartomato to the kitchen.'
          frontpad:
            title: 'Frontpad'
            description: 'Sending confirmed orders from Smartomato to the kitchen.'
          sbis:
            title: 'СБИС Presto'
            description: 'Sending confirmed orders from Smartomato to the kitchen.'
        aquiring:
          title: 'Acquiring'
          yandex:
            title: 'Yandex.Checkout'
            description: 'Accept payment online. Bank cards Visa, Mastercard, Maestro, Mir, JCB, Diners Club, American Express. Yandex money. QIWI Wallet. '
          cloud_payments:
            title: 'Cloudpayments'
            description: 'Accept payment online. Bank cards Visa, Mastercard, Maestro, Mir. '
          sberbank:
            title: 'Sberbank'
            description: 'Accept payment online. Bank cards Visa, Mastercard, Maestro, Mir. '
          ibox:
            title: 'iBox'
            description: 'Acceptance of non-cash payments using a smartphone and a mobile terminal. Bank cards Visa, Mastercard, Maestro, Mir '
          pay_keeper:
            title: 'PayKeeper'
            description: 'Acquiring from banks: VTB, Sberbank, Promsvyazbank, Otkritie Bank, Moscow Credit Bank, Russian Standard Bank, TransCapitalBank, Gazprombank, URALSIB BANK, Bank Saint Petersburg, UBRD, POCHTA BANK, QIWI Bank'
          alfa_bank:
            title: 'Alfa Bank'
            description: 'Accept payment online. Bank cards Visa, Mastercard, Maestro, Mir. '
          tinkoff:
            title: 'Tinkoff'
            description: 'Accept payment online. Bank cards Visa, Mastercard, Maestro, Mir. '
          yandex_check:
            title: 'Yandex.Check'
            description: 'Accept payment online. Bank cards Visa, Mastercard, Maestro, Mir. '
        loyalty:
          title: 'Loyalty systems'
          sber_food:
            title: 'SberFood'
            description: 'Restaurants using SberFood track data on the use of bonuses in the Smartomato interface, and restaurant guests accumulate and spend bonuses when ordering delivery.'
          premium_bonus:
            title: 'Premium Bonus'
            description: 'Single bonus guest account - when visiting a restaurant offline and when ordering delivery. Two-way synchronization of customer data, accumulation and write-off of bonuses. '
          iiko_card:
            title: 'iikoCard'
            description: 'A bonus-deposit system designed for managing relationships with regular guests, supporting corporate dining schemes.'
          primehill:
            title: 'PrimeHill'
            description: 'Convenient system for automating marketing communications.'
        analytics:
          title: 'End-to-End Analytics'
          calltouch:
            title: 'Calltouch'
            description: 'Automatic transmission of information about orders by phone in the form of transactions in Calltouch and assignment of advertising sources.'
        delivery_outsource:
          title: 'Delivery Outsourcing'
          yandex_go:
            title: 'Yandex.Delivery'
            description: 'Automatic creation and transmission of a delivery request from Smartomato to Yandex.Delivery, synchronization of order statuses, subsidy settings and detailed reports.'
          dostavista:
            title: 'Dostavista'
            description: 'Full automation: calculation of the cost and delivery time, transmission of a delivery request, synchronous exchange of order statuses, reporting.'
          broniboy:
            title: 'Broniboy'
            description: 'Automatic creation and submission of delivery requests from Smartmato to Broniboy, synchronization of order statuses, subsidy settings, and detailed reports.'
        messaging:
          title: 'SMS and Messengers'
          main_sms:
            title: 'MainSMS'
            description: 'SMS to clients with the selected sender name.'
          smsc:
            title: 'SMS Center'
            description: 'SMS to clients with the selected sender name.'
          megafon:
            title: 'Megafon'
            description: 'SMS to clients with the selected sender name.'
          infobip:
            title: 'Infobip'
            description: 'SMS to clients with the selected sender name. Sending messages to messengers - in development'
          whatsapp:
            title: 'WhatsApp'
            description: 'Sending messages from the official business account to users on the WhatsApp messenger.'
          sms_agent:
            title: 'SMS-agent'
            description: 'SMS to clients with the selected sender name.'
          beeline:
            title: 'Beeline'
            description: 'SMS to clients with the selected sender name.'
          mts:
            title: 'MTS Marketer'
            description: 'SMS to clients with the chosen sender name.'
          sms_aero:
            title: 'SMS Aero'
            description: 'SMS to clients with the chosen sender name.'
        aggregators:
          title: 'Aggregators'
          yandex_eda:
            title: 'Yandex.Food'
            description: 'Uploading the restaurant menu to the service. Processing orders received via Yandex.Food (import, notifications, cancellation, status update). '
          delivery_club:
            title: 'Delivery Club'
            description: 'Uploading the restaurant menu to the service. Processing orders received via Delivery Club (import, notification, cancellation, status update). '
          broniboy:
            title: 'Broniboy'
            description: 'Uploading the restaurant menu to the service. Processing received orders (import, notification, cancellation, status update). '
          obed_ru:
            title: 'Obed.ru'
            description: 'Import of orders received through Obed.ru'
          zakazaka:
            title: 'ZakaZaka'
            description: 'Uploading the restaurant menu to the service. Processing orders received through Zakazaka (import, notification, cancellation, status update). '
          chibbis:
            title: 'Chibbis'
            description: 'Uploading the restaurant menu to the service. Processing orders received through Chibbis (import, notification, cancellation, status update). '
          glovo:
            title: 'Glovo'
            description: 'Uploading the restaurant menu to the service. Processing orders received through Glovo (import, notification, cancellation, status update). '
          vk:
            title: 'Vk'
            description: 'Uploading the restaurant menu to the service. Processing orders received through Vk (import, notification, cancellation, status update). '
          sbermarket:
            title: 'Sbermarket'
            description: 'Uploading the restaurant menu to the service. Processing orders received through Sbermarket (import, notification, cancellation, status update). '
      buttons:
        connect: 'Connect'
    payments:
      title: 'Methods of payment for an order by clients'
      subtitle:' Manage the availability of choice of payment methods when placing an order '
      feature:
        description: 'Specify the payment methods that the client can choose when placing an order. Please note that some payment methods require additional settings. '
        cash:
          title: 'Cash upon receipt'
          description: 'Payment is made to your courier upon receipt of the order. In this case, on the order form, there will be a question about the need for the courier to have change with him with the amount specified by the client. No additional configuration is required for this service to work. '
        card_online:
          title: 'By card online'
          caption:
            before_support: 'After placing an order, the client will be asked to enter the card details to pay for the order. For this payment method to work, integration with Internet acquiring is required, it\'s not a problem - '
            support: 'message us'
            after_support: 'and we will do everything.'
        courier_card:
          title: 'By card upon receipt'
          description: 'This method of payment is possible if your couriers have mobile terminals. <a href="https://play.google.com/store/apps/details?id=en.smartomato.ordermachine" target="_blank"> Smartomato courier app </a> has integration with <a href = "http://iboxmpos.com/" target = "_blank"> iboxPro </a>, a service that allows you to accept cards using your smartphone. '
    profile:
      title: 'Profile settings'
      subtitle: 'Here you can edit your profile'
      labels:
        photo: 'Avatar'
        name: 'Name'
        phone: 'Phone'
        login: 'Email'
        password: 'Password'
        password_repeat: 'Confirmation'
      placeholders:
        name: 'Name'
        phone: 'Enter phone number'
        login: 'Enter email'
        password: 'Enter password'
        password_repeat: 'Confirm password'
    developer_settings:
      title: 'Additional features'
      subtitle:' Settings and functions section for advanced users '
      feature:
        import_menu:
          title:' Import menu '
          description:' <p> Batch load organization menu from JSON file. Before using, read the description of the file format in <a href="http://developer.smartomato.com/api"> documentation for Smartomato developers. </a> </p>
                       <p> Attention! The previous menu will be completely replaced with the imported one, which can lead to the loss of statistics. </p> '
        export_menu:
          title: 'Export Menu'
          description: '<p>Export the menu as a JSON file</p>'
          action: 'Export'
          description_yml: '<p>Export menu as a YML file</p>'
          all_menu: 'Entire menu'

        import_clients:
          title:' Importing clients '
          description:' <p> Batch load organization\'s client data from a JSON file. Before use, read the description of the file format in
                        <a href="http://developer.smartomato.com/api"> documentation for Smartomato developers. </a> </p> '
          label:' Delete previously created clients'
        board2:
          title: 'Board2'
          description: '<p>Board2 is a separate interface for configuring integrations and specific features of Smartomato.</p>
                        <p><a href="//smartomato.ru/board2" target="_blank">Open in a new tab</a></p>'
    interface:
      title: 'Interface settings'
      subtitle: 'The operating parameters for a specific browser'
      feature:
        language:
          label: 'Language of this interface'
          caption: 'This setting changes ONLY the user interface in the current browser, no organization settings will be changed'
        low_perfomance:
          description: 'Enable if you have a lot of orders, the computer cannot cope and the interface loses responsiveness'
          disable: 'Default mode, no restrictions'
          enable : 'Now the interface displays less information and tries to update it less often'
        hide_map:
          description: 'Do not display the map on the bookmark with orders'
          enable: 'The map is hidden, this will also reduce the load on the computer'
          disable: 'The map will be displayed'
        map_mouse_wheel:
          description: 'Change map zoom value with mouse wheel'
          enable: 'Mouse wheel will zoom'
          disable: 'Mouse wheel will scroll'
        check_interval:
          description: 'Frequency of update of checkpoints in orders'
          enable: 'The update interval is set to {{interval}} min.'
        notification_duration:
          description: 'How long to show the toast notification'
          enable: 'Notifications will hide after {{interval}} sec.'
        hide_order_notifications:
          description: 'Hide notifications about new orders and their status changes'
          enable:' Notifications are hidden '
          disable:' Notifications are displayed '
        hide_pickup_orders_at_now:
          description: 'Hide takeaway orders at Now section'
          enable: 'Takeaway orders will not be shown'
          disable: 'All orders are shown'
        sound_notifications:
          description:' Play sound notifications when a new order arrives'
          enable: '<br> Sound notifications are enabled! '
        sound_notifications_verbose:
          description: 'Play sound notifications on any event (not recommended)'
          enable: '<br> 🎉🥁🥳🎊!'
        sound_notifications_repeat:
          description: 'Repeat sound notifications when a new order arrives'
          enable: '<br>Repeat of sound notifications is enabled!'
        repeat_interval:
          description: 'Frequency of repeat sound notifications'
          enable: 'Repeat interval {{interval}} sec.'
        integrations_settings:
          description: 'Open the integration settings inside the control panel'
          enable: '<br>The integration settings are no longer in a separate window!'
        hide_later_orders_on_map:
          description: 'Hide "Later" orders on the map'
          enable: '<br>Only "Now" orders will appear on the map'
        hide_unauthorized_couriers:
          description: 'Hide unauthorized couriers on the map'
          enable: '<br>Only working couriers will be displayed on the map'
        show_button_for_optional_modifiers:
          description: 'Separate button for optional modifiers in the order card'
          enable: '<br>Mandatory modifiers will be available by clicking on the dish, optional modifiers will be available by clicking on the button next to the dish'
        show_dish_photo_in_order_card:
          description: 'Show photos of dishes in the order card'
          enable: '<br>Photos of dishes will be shown on the order card'
        show_assigned_courier_in_order_card:
          description: 'Show selected courier in order card'
          enable: '<br>The selected courier will be displayed in the order card on now\\later tabs'


  sm_chosen:
    nothing_found: 'Nothing found'
    buttons:
      add_button: 'Add'
    placeholders:
      search: 'search'

  date_range_report:
    from: 'from'
    to: 'to'

  day_editor:
    to: ' till '
    add: 'Add'
    time_hint: 'To add a period, you need to adjust the previous period, it should not end at 23:59'
    not_working: 'Closed'

  sm_delivery_map:
    buttons:
      finish: 'Finish'
      cancel: 'Cancel'

  sm_button:
    back: 'Back'
    save: 'Save'
    cancel: 'Cancel'
    delete: 'Delete'
    upload: 'Upload'
    change: 'Change'

  sm_notification_limiter:
    text: 'And more {{noticifationPending}} notifications '
    hide_all:' hide all notifications'

  tariff:
    price_text: '{{tarrifPrice}} r/month'
    buttons:
      select_tariff: 'Choose'
    full_tariffs: 'Full tariffs table and its comparison at <a href="https://smartomato.ru/pricing" target="_blank">Smartomato site</a>.'

  available:
    available: 'Available'
    not_available: 'On the stop list'
    call: 'Check availability by phone'

  validation:
    phone: 'The phone number must contain only numbers and +'
    login: 'Incorrect email'
    required_field: 'Required field'

  errors:
    status: 'Status cannot be set.'
    code:
      403: 'Insufficient rights to perform this action.'
